import React, { useEffect, useContext, useState, useMemo, useRef } from "react";
import { TokenVerificationLoggedin, /*BlockAdmin,*/ ScreenView } from "../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../config/config.json";
import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import { notifycatch } from "../utils/toast";
import reportInfo from '../assets/images/icons/report_info.svg';
// import JSZip from "jszip";
// import FileSaver from "file-saver";
import Dropdown from 'react-bootstrap/Dropdown';
// import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import SheetIcon from '../assets/images/icons/sheet_icon.svg';
import AdsTxtIcon from '../assets/images/icons/ads_txt_icon.svg';
import { Table, Tooltip, Radio, Select, Col, Row, Pagination, Input, Button, Modal, Progress, Checkbox, Cascader } from 'antd';
import infoIcon from '../assets/images/icons/info.svg';
// import InventoryProcessingLoader from "../assets/images/inventory_processing_loader.gif"
import { SearchOutlined } from '@ant-design/icons';
import HoverCloseIcon from '../assets/images/icons/hover_close.svg';
// import filterIcon from '../assets/images/icons/filter.svg';
// import columnIcon from '../assets/images/icons/column.svg'
import crossIcon from '../assets/images/icons/cross.svg';
import checkIcon from '../assets/images/icons/check.svg';
// import mediaKitIcon2 from '../assets/images/icons/export_download_icon.svg';
import { saveAs } from "file-saver";
import { Link } from 'react-router-dom'
import FullLoader from "../assets/images/full-page-loader.gif"
import Edit from '../assets/images/icons/edit.svg';
import prevIcon from '../assets/images/icons/chevron-left.svg';
import nextIcon from '../assets/images/icons/chevron-right.svg';
import noData from '../assets/images/data-graph/no-data.svg';
import errorData from '../assets/images/data-graph/error-data.svg';
// import loaderIcon from "../assets/images/login-and-signup/loader.gif";
import uploadIcon from '../assets/images/icons/upload-cloud.svg';
import DeleteIcon from '../assets/images/icons/delete_icon.svg';
import LinkIcon from '../assets/images/link_icon.svg';
import { PlusOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import { Upload/*, message*/ } from "antd";
import { jwtDecode } from "jwt-decode";
import TableLoader from "./TableLoader";
import { Form, Typography } from "antd";
import { useOnboardingStep } from '../context/OnboardingStepContext';
const { Option } = Select;



// const GaugeItem = ({ value, color, data }) => (
//     <Progress
//         type="dashboard"
//         percent={value}
//         gapDegree={180}
//         size={48}
//         gapPosition="bottom"
//         strokeColor={color}
//         strokeWidth={10}
//         format={(val) => (
//             <span style={{ color, fontSize: 13, fontWeight: 600 }}>
//                 {data}
//             </span>
//         )}
//     />
// );

const formatNumberComma = (value) => {
    if (value === null || value === undefined || value === "") return 0;

    const [integerPart, decimalPart] = String(value).split(".");
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return decimalPart !== undefined ? `${formattedInteger}.${decimalPart}` : formattedInteger;
};



export const inventoryTemplates = {
    "Website": {
        // key: { headerName, required, type: "text"|"number"|"url"|"select", options?, mandatory? }
        inventory_provider: { header: "Inventory Provider (Select “Owned & Operated” if you own the property)", required: true, type: "select", options: ["O&O", "Resold"] },
        domain: { header: "Domain", required: true, type: "url" },
        traffic_type: { header: "Traffic Type (Banner/Video/Native)", required: true, type: "select", options: ["Banner", "Video", "Native"] },
        // geo: { header: "Geo", required: true, type: "text" },
        geo: {
            header: "Geo",
            required: true,
            type: "select",
        },
        avg_ecpm: { header: "Average eCPM ($)", required: false, type: "number" },
        last_30_avails: { header: "Last 30 days Avails", required: true, type: "number" }
    },
    "Mobile App": {
        inventory_provider: { header: "Inventory Provider (Select “Owned & Operated” if you own the property)", required: true, type: "select", options: ["O&O", "Resold"] },
        app_bundle: { header: "App bundle", required: true, type: "text" },
        app_store_url: { header: "App Store URL", required: false, type: "url" },
        app_name: { header: "App Name", required: false, type: "text" },
        app_ads_txt_url: { header: "App-ads.txt URL", required: true, type: "url" },
        traffic_type: { header: "Traffic Type (Banner/Video/Native)", required: true, type: "select", options: ["Banner", "Video", "Native"] },
        geo: {
            header: "Geo",
            required: true,
            type: "select",
        },
        // geo: { header: "Geo", required: true, type: "text" },
        avg_ecpm: { header: "Average eCPM ($)", required: false, type: "number" },
        last_30_avails: { header: "Last 30 days Avails", required: true, type: "number" }
    },
    "CTV": {
        inventory_provider: { header: "Inventory Provider (Select “Owned & Operated” if you own the property)", required: true, type: "select", options: ["O&O", "Resold"] },
        store: {
            header: "Store (Android/IOS/LG/etc)", required: true, type: "select", options: [
                "Samsung Smart Hub",
                "Google Play (Android TV)",
                "LG Content Store",
                "Amazon Appstore",
                "Roku Channel Store",
                "Vizio App Store",
                "Apple App Store (tvOS)",
                "Xiaomi GetApps (PatchWall)",
                "Jio Store",
                "VIDAA (Hisense)",
                "WhaleStore (Zeasn)",
                "Titan OS",
                "TiVo OS",
                "Sky Q / Sky Glass",
                "Foxxum App Store",
                "NetRange",
                "Xbox Store",
                "PlayStation Store",
                "Xfinity X1 / Flex",
                "Panasonic App Store",
                "Huawei AppGallery",
                "Metrological Store",
                "Aptoide TV",
                "Vewd (now Xperi)",
                "Vestel Smart Center",
                "Samba TV",
                "Fetch TV Store",
                "Freebox OS Store",
                "Magenta TV Store",
                "UPC / Liberty Global"
            ]
        },
        app_bundle: { header: "App bundle", required: true, type: "text" },
        app_name: { header: "App Name", required: true, type: "text" },
        app_store_url: { header: "App Store URL", required: true, type: "url" },
        app_ads_txt_url: { header: "App-ads.txt URL", required: true, type: "url" },
        inventory_partner_domain: { header: "Inventory Partner Domain URL", required: false, type: "url" },
        // geo: { header: "Geo", required: true, type: "text" },
        geo: {
            header: "Geo",
            required: true,
            type: "select",
        },
        avg_ecpm: { header: "Average eCPM ($)", required: false, type: "number" },
        last_30_avails: { header: "Last 30 days Avails", required: true, type: "number" }
    }
};

const parseExcelFile = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const workbook = XLSX.read(arrayBuffer, { type: "array" });
    // assume first sheet is the data sheet:
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    // Convert to JSON with raw values replaced by blank if undefined
    const json = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
    return json; // array of objects where keys are header titles
};


const InventoryListing = (props) => {
    const { setMsgInventory } = useOnboardingStep();
    const loadingContext = useContext(LoadingContext);
    const isRegisterFlow = props.callFrom === "register";
    const registerPubId = props.pubId || "";

    const [apiCall, setApicall] = useState(false)
    const [checkRole, setCheckRole] = useState("admin")

    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState("");
    const [/* editingKeyStatus */, setEditingKeyStatus] = useState("");
    const isEditing = (record) => record._id === editingKey;

    const editableFieldsByType = {
        web: ["inventory_provider", "traffic_type", "geo", "avg_ecpm", "last_30_avails"],
        mobile: ["inventory_provider", "app_name", "app_ads_txt_url", "traffic_type", "geo", "avg_ecpm", "last_30_avails"],
        ctv: ["inventory_provider", "store", "app_name", "app_ads_txt_url", "inventory_partner_domain", "geo", "avg_ecpm", "last_30_avails"],
    };

    const [countryOptions, setCountryOptions] = useState([]);

    const validateHeadersAndRows = (rows, template) => {
        // rows: array of objects with keys equal to header labels
        // template: the template object for chosen inventory type
        const headerMap = {}; // map header->key
        // Build map from template header strings to internal keys
        for (const [key, meta] of Object.entries(template)) headerMap[meta.header.trim()] = key;

        // Check all required headers exist in the sheet
        const sheetHeaders = rows.length > 0 ? Object.keys(rows[0]).map(h => h.trim()) : [];

        const missingHeaders = [];
        for (const meta of Object.values(template)) {
            if (meta.required && !sheetHeaders.includes(meta.header.trim())) {
                missingHeaders.push(meta.header);
            }
        }
        if (missingHeaders.length) {
            return { ok: false, errors: [`Missing required columns: ${missingHeaders.join(", ")}`] };
        }

        // Validate rows
        const errors = [];
        const normalizedRows = rows.map((row, rowIndex) => {
            const normalized = {};
            for (const [header, value] of Object.entries(row)) {
                const trimmedHeader = header.trim();
                const key = headerMap[trimmedHeader];
                if (!key) continue; // ignore unknown columns
                const meta = template[key];
                let cellVal = value;

                // Type checking
                if (meta.type === "number") {
                    if (cellVal === "" || cellVal === null) {
                        if (meta.required) errors.push(`Row ${rowIndex + 2}: ${meta.header} is required`); // +2 because sheet header + 1-based
                    } else if (isNaN(Number(cellVal))) {
                        errors.push(`Row ${rowIndex + 2}: ${meta.header} must be a number`);
                    } else {
                        cellVal = Number(cellVal);
                    }
                } else if (meta.type === "url") {
                    if (cellVal) {
                        const raw = String(cellVal).trim();
                        const domainLikeRegex = /([a-z0-9-]+\.[a-z0-9-.]+)/i;

                        if (!domainLikeRegex.test(raw)) {
                            errors.push(`Row ${rowIndex + 2}: ${meta.header} must contain a valid domain (e.g., example.com)`);
                        } else {
                            cellVal = raw; // keep original input
                        }
                    } else if (meta.required) {
                        errors.push(`Row ${rowIndex + 2}: ${meta.header} is required`);
                    }
                }
                // else if (meta.type === "select") {
                //     if (cellVal) {
                //         const allowed = meta.options || [];
                //         if (!allowed.includes(String(cellVal).trim())) {
                //             errors.push(`Row ${rowIndex + 2}: ${meta.header} must be one of: ${allowed.join(", ")}`);
                //         }
                //     } else if (meta.required) {
                //         errors.push(`Row ${rowIndex + 2}: ${meta.header} is required`);
                //     }
                // }
                else if (meta.type === "select") {
                    if (cellVal) {

                        let allowed = meta.options || [];
                        if (meta.header === "Geo") {
                            allowed = countryOptions?.map(
                                c => c.label.toLowerCase()
                            ) || [];
                        }
                        else {
                            allowed = meta.options || [];
                        }

                        if (!allowed.includes(String(cellVal).trim())) {
                            if (meta.header === "Geo") {
                                errors.push(`Row ${rowIndex + 2}: ${meta.header} is not a valid option.`);
                            }
                            else {
                                errors.push(`Row ${rowIndex + 2}: ${meta.header} must be one of: ${allowed.join(", ")}`);
                            }

                        }
                    } else if (meta.required) {
                        errors.push(`Row ${rowIndex + 2}: ${meta.header} is required`);
                    }
                }
                else { // text
                    if ((cellVal === "" || cellVal === null) && meta.required) {
                        errors.push(`Row ${rowIndex + 2}: ${meta.header} is required`);
                    }
                }

                normalized[key] = cellVal;
            }
            return normalized;
        });

        return { ok: errors.length === 0, normalizedRows, errors };
    };



    const buildRules = (meta) => {
        const rules = [];

        if (meta.required) {
            rules.push({ required: true, message: "This field is required" });
        }

        if (meta.type === "url") {
            rules.push({
                validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    const domainRegex = /([a-z0-9-]+\.[a-z0-9-.]+)/i;
                    return domainRegex.test(value)
                        ? Promise.resolve()
                        : Promise.reject("Invalid URL");
                },
            });
        }

        if (meta.type === "number") {
            rules.push({
                validator: (_, value) =>
                    value === undefined || value === "" || !isNaN(value)
                        ? Promise.resolve()
                        : Promise.reject("Invalid number"),
            });
        }

        if (meta.type === "select" && meta.options?.length) {
            rules.push({
                validator: (_, value) =>
                    !value || meta.options.includes(value)
                        ? Promise.resolve()
                        : Promise.reject("Invalid selection"),
            });
        }

        return rules;
    };

    const edit = (record) => {
        // setSelectedRowKeysBackup(selectedRowKeys)
        // setSelectedRowIdsBackup(selectedRowIds)
        setSelectedRowKeys([record._id]);
        setSelectedRowIds([record._id]);
        setEditingKey(record._id);
        setEditingKeyStatus(record.status)


        setTimeout(() => {

            form.setFieldsValue(record);

        }, 0);
    };

    const cancel = () => {
        form.resetFields();
        setEditingKey("");
        setSelectedRowKeys([])
        setSelectedRowIds([])
        setEditingKeyStatus("")
        // setSelectedRowKeys(selectedRowKeysBackup)
        // setSelectedRowIds(selectedRowIdsBackup)
    };


    // const save = async (_id) => {
    //     try {
    //         // 1️⃣ Validate edited row only
    //         const values = await form.validateFields();

    //         // 2️⃣ Find original row
    //         const originalRow = data.find(row => row._id === _id);
    //         if (!originalRow) return;

    //         // 3️⃣ Merge old + edited values
    //         const updatedRow = {
    //             ...originalRow,
    //             ...values,
    //         };

    //         // 4️⃣ Build API payload (EXACT backend format)
    //         const payload = {
    //             inventoryType: filter === "web" ? "web" : filter === "mobile" ? "mobile" : "ctv",
    //             inventoryId: _id,
    //             data: [
    //                 {
    //                     key: updatedRow.key,
    //                     inventory_provider: updatedRow.inventory_provider,
    //                     domain: updatedRow.domain,
    //                     status: updatedRow.status,
    //                     traffic_type: updatedRow.traffic_type,
    //                     geo: updatedRow.geo,
    //                     avg_ecpm: Number(updatedRow.avg_ecpm),
    //                     last_30_avails: Number(updatedRow.last_30_avails),
    //                 }
    //             ]
    //         };

    //         // 5️⃣ API call
    //         // await axios.post(
    //         //     "http://localhost:4000/api/v1/ops/editInventory",
    //         //     payload
    //         // );

    //         // // 6️⃣ Update table only AFTER success
    //         // setData(prev =>
    //         //     prev.map(row =>
    //         //         row._id === _id ? updatedRow : row
    //         //     )
    //         // );

    //         // // 7️⃣ Reset UI states
    //         // setEditingKey("");
    //         // setSelectedRowKeys([]);
    //         // setSelectedRowIds([]);
    //         // form.resetFields();


    //         let status = Cookies.get("token_xapads_ssp") ? true : false;
    //         if (status) {
    //             let token = Cookies.get("token_xapads_ssp");
    //             axios
    //                 .post(configData.SERVER_URL + `ops/editInventory`, payload

    //                     , {
    //                         headers: {
    //                             "Content-Type": "application/json",
    //                             "x-access-token": token,
    //                         },
    //                     })
    //                 .then((response) => {
    //                     if (response.data.status) {

    //                         notifysuccess(response.data.message)

    //                         setData(prev =>
    //                             prev.map(row =>
    //                                 row._id === _id ? updatedRow : row
    //                             )
    //                         );

    //                         // 7️⃣ Reset UI states
    //                         setEditingKey("");
    //                         setSelectedRowKeys([]);
    //                         setSelectedRowIds([]);
    //                         setEditingKeyStatus("")
    //                         form.resetFields();

    //                     }
    //                     else {
    //                         notifyfailure(response.data.message)
    //                     }


    //                 })
    //                 .catch((error) => {
    //                     if (error?.response) {
    //                         if (error.response.data.message?.length !== 0) {
    //                             notifyfailure(error.response.data.message)
    //                         }
    //                     } else {
    //                         notifycatch()
    //                     }
    //                 });
    //         }



    //     } catch (error) {
    //         // ❌ Validation errors come here automatically
    //         // console.error("Save failed:", error);
    //     }
    // };


    const save = async (_id) => {
        try {
            // 1️⃣ Validate only edited fields
            const values = await form.validateFields();

            // 2️⃣ Find original row
            const originalRow = data.find(row => row._id === _id);
            if (!originalRow) return;

            // 3️⃣ Merge old + edited values
            const updatedRow = {
                ...originalRow,
                ...values,
            };

            // 4️⃣ Build row object based on inventory type
            let rowPayload = {};

            if (filter === "web") {
                rowPayload = {
                    key: updatedRow.key,
                    inventory_provider: updatedRow.inventory_provider,
                    domain: updatedRow.domain,
                    status: updatedRow.status,
                    traffic_type: updatedRow.traffic_type,
                    geo: updatedRow.geo,
                    avg_ecpm: Number(updatedRow.avg_ecpm),
                    last_30_avails: Number(updatedRow.last_30_avails),
                };
            }

            if (filter === "mobile") {
                rowPayload = {
                    key: updatedRow.key,
                    inventory_provider: updatedRow.inventory_provider,
                    app_bundle: updatedRow.app_bundle,
                    status: updatedRow.status,
                    app_name: updatedRow.app_name,
                    app_store_url: updatedRow.app_store_url,
                    app_ads_txt_url: updatedRow.app_ads_txt_url,
                    traffic_type: updatedRow.traffic_type,
                    geo: updatedRow.geo,
                    avg_ecpm: Number(updatedRow.avg_ecpm),
                    last_30_avails: Number(updatedRow.last_30_avails),
                };
            }

            if (filter === "ctv") {
                rowPayload = {
                    key: updatedRow.key,
                    inventory_provider: updatedRow.inventory_provider,
                    status: updatedRow.status,
                    store: updatedRow.store,
                    app_bundle: updatedRow.app_bundle,
                    app_name: updatedRow.app_name,
                    app_store_url: updatedRow.app_store_url,
                    app_ads_txt_url: updatedRow.app_ads_txt_url,
                    inventory_partner_domain: updatedRow.inventory_partner_domain || "",
                    geo: updatedRow.geo,
                    avg_ecpm: Number(updatedRow.avg_ecpm),
                    last_30_avails: Number(updatedRow.last_30_avails),
                };
            }

            // 5️⃣ Final API payload
            const payload = {
                inventoryType: filter === "web" ? "web" : filter === "mobile" ? "mobile" : "ctv",
                inventoryId: _id, // ⚠️ MUST be inventory id, not row _id
                data: [rowPayload],
            };

            // 6️⃣ API call
            const token = isRegisterFlow ? null : Cookies.get("token_xapads_ssp");
            if (!isRegisterFlow && !token) return;

            const editQueryParam = isRegisterFlow ? `?_id=${registerPubId}` : "";
            axios.post(
                configData.SERVER_URL + `ops/editInventory${editQueryParam}`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        ...(token ? { "x-access-token": token } : {}),
                    },
                }
            )
                .then((response) => {
                    if (response.data.status) {
                        notifysuccess(response.data.message);

                        // 7️⃣ Update table ONLY after success
                        setData(prev =>
                            prev.map(row =>
                                row._id === _id ? updatedRow : row
                            )
                        );

                        // 8️⃣ Reset UI state
                        setEditingKey("");
                        setEditingKeyStatus("");
                        setSelectedRowKeys([]);
                        setSelectedRowIds([]);
                        form.resetFields();
                    } else {
                        notifyfailure(response.data.message);
                    }
                })
                .catch((error) => {
                    if (error?.response?.data?.message) {
                        notifyfailure(error.response.data.message);
                    } else {
                        notifycatch();
                    }
                });

        } catch (error) {
            // validation errors handled by antd
        }
    };




    // const COLVIS_KEYS_BY_TYPE = {
    //     web: [
    //         // "p_name",
    //         "ownerDomain",
    //         "risk",
    //         "iabPrimaryCategories",
    //         "iabSubCategories",
    //         "rejectionReason",
    //         "ivt",
    //         "sivt",
    //         "givt",
    //         "viewability",
    //         "mfaRisk",
    //         "trafficQualityRisk",
    //         "brandSafetyRisk",
    //         "siteRisk"
    //     ],
    //     mobile: [
    //         // "p_name",
    //         "app_bundle",
    //         "app_store_url",
    //         "rejectionReason",
    //     ],
    //     ctv: [
    //         // "p_name",
    //         "app_bundle",
    //         "app_store_url",
    //         "rejectionReason",
    //     ],
    // };

    const [filter, setFilter] = useState("web")




    // const [colvisByType] = useState({
    //     web: {},
    //     mobile: {},
    //     ctv: {},
    // });

    // const activeColvis = colvisByType[filter];



    // const buildColvisLabelMap = (columns) => {
    //     const map = {};
    //     const walk = (cols) => {
    //         cols.forEach(col => {
    //             if (col.key && col.title && typeof col.title === "string") {
    //                 map[col.key] = col.title;
    //             }
    //             if (col.children) {
    //                 walk(col.children);
    //             }
    //         });
    //     };
    //     walk(columns);
    //     return map;
    // };




    // const exportHeader = [
    //     { label: "Status", key: "Status" },
    //     { label: "Name", key: "Name" },
    //     { label: "Organization Name", key: "Organization Name" },
    //     { label: "Email", key: "Email" },
    //     { label: "Website", key: "Website" },
    //     { label: "IM", key: "IM" },
    //     { label: "Country", key: "Country" },
    //     { label: "Zones", key: "zone" },
    //     { label: "AM", key: "AM" },
    //     { label: "Seller Type", key: "Seller Type" },
    //     { label: "GAM Integration", key: "GAM Integration" },
    //     { label: "ADK ID", key: "ADK ID" },
    //     { label: "Aniview ID", key: "Aniview ID" },
    //     { label: "GAM ID", key: "GAM ID" },
    //     { label: " Gross Ad Count", key: "impressions" },
    //     { label: "GIVT Ad Count", key: "givtImpressions" },
    //     { label: "SIVT Ad Count", key: "sivtImpressions" },
    //     { label: "IVT", key: "givtSivtImp" },
    //     { label: "Net Viewability", key: "viewability" },
    //     { label: "Discrepancies", key: "discrep" },
    //     { label: "Updated At (UTC)", key: "pix_updatedAt" },
    // ]

    const [exportLoading, setExportLoading] = useState(false)

    // function addCommasToNumber(num) {
    //     const isDecimal = num % 1 !== 0;
    //     let numStr = num.toString();
    //     let [wholePart, decimalPart] = numStr.split(".");
    //     wholePart = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //     if (isDecimal) {
    //         numStr = `${wholePart}.${decimalPart}`;
    //     } else {
    //         numStr = wholePart;
    //     }
    //     return numStr;
    // }

    const [platformTotal, setPlatformTotal] = useState({ "web": 0, "mobile": 0, "ctv": 0 });
    const [countRecords, setCountRecords] = useState({ approved: 0, rejected: 0, pending: 0 });

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowIds, setSelectedRowIds] = useState([]);
    // const [selectedRowKeysBackup, setSelectedRowKeysBackup] = useState([]);
    // const [selectedRowIdsBackup, setSelectedRowIdsBackup] = useState([]);
    // const rowSelection = {
    //     type: "checkbox",
    //     selectedRowKeys,

    //     onChange: (newSelectedRowKeys, selectedRows) => {
    //         setSelectedRowKeys(newSelectedRowKeys);

    //         const ids = selectedRows.map(row => row._id);
    //         setSelectedRowIds(ids);
    //     },

    //     getCheckboxProps: (record) => ({
    //         disabled: record.status !== "pending"
    //     })
    // };

    // const rowSelection = useMemo(() => ({
    //     type: "checkbox",
    //     selectedRowKeys,
    //     preserveSelectedRowKeys: true, // Add this line

    //     onChange: (newSelectedRowKeys, selectedRows) => {
    //         setSelectedRowKeys(newSelectedRowKeys);
    //         setSelectedRowIds(newSelectedRowKeys);
    //     },


    //     getCheckboxProps: (record) => ({
    //         disabled: record.status !== "pending"
    //     })
    // }), [selectedRowKeys]);

    // const rowSelection = {
    //     type: "checkbox",
    //     selectedRowKeys,

    //     onChange: (newSelectedRowKeys) => {
    //         setSelectedRowKeys(newSelectedRowKeys);
    //         setSelectedRowIds(newSelectedRowKeys); // Since rowKey is _id, these are the same
    //     },

    //     getCheckboxProps: (record) => ({
    //         disabled: record.status !== "pending"
    //     })
    // };

    const rowSelection = {
        type: "checkbox",
        preserveSelectedRowKeys: true,
        selectedRowKeys,
        // selectedRowKeys: editingKey ? [] : selectedRowKeys,

        onChange: (newSelectedRowKeys) => {
            if (editingKey) return; // block selection while editing
            setSelectedRowKeys(newSelectedRowKeys);
            setSelectedRowIds(newSelectedRowKeys);
        },

        getCheckboxProps: (record) => ({
            // disabled: editingKey || record.status !== "pending",
            disabled: editingKey,
        }),
    };

    // const rowSelection = editingKey
    //     ? null
    //     : {
    //         type: "checkbox",
    //         preserveSelectedRowKeys: true,
    //         selectedRowKeys,
    //         onChange: (newSelectedRowKeys) => {
    //             setSelectedRowKeys(newSelectedRowKeys);
    //             setSelectedRowIds(newSelectedRowKeys);
    //         },
    //         getCheckboxProps: (record) => ({
    //             disabled: record.status !== "pending",
    //         }),
    //     };



    // const EditableCell = ({ editing, dataIndex, record, children, ...rest }) => {
    //     // Don't apply custom rendering to the selection column
    //     if (!dataIndex) {
    //         return <td {...rest}>{children}</td>;
    //     }

    //     return (
    //         <td {...rest}>
    //             {editing ? (
    //                 <div className='form_content_block--group'>
    //                     <Input
    //                         size="small"
    //                         className='form_control basic p-3 h_31'
    //                         defaultValue={record[dataIndex]}
    //                     />
    //                 </div>
    //             ) : (
    //                 children
    //             )}
    //         </td>
    //     );
    // };

    const EditableCell = ({
        editing,
        dataIndex,
        inputType,
        options,
        rules,
        children,
        ...rest
    }) => {
        // 🚨 CRITICAL GUARD
        // If no dataIndex → let AntD handle the cell
        if (!dataIndex) {
            return <td {...rest}>{children}</td>;
        }

        // 🚨 CRITICAL GUARD
        // If not editing → render normal cell
        if (!editing) {
            return <td {...rest}>{children}</td>;
        }

        let inputNode = <Input />;

        if (inputType === "select") {

            if (dataIndex === "geo") {
                inputNode = (
                    <Select
                        showSearch
                        placeholder="Select country"
                        suffixIcon={
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M5 7.5L10 12.5L15 7.5" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        }
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                            option?.label?.toLowerCase().includes(input.toLowerCase())
                        }
                        options={options} // label/value from API
                        style={{ width: "100%" }}
                    />
                );
            }
            else {
                inputNode = (
                    <Select
                        style={{ width: "100%" }}
                        suffixIcon={
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M4 6L8 10L12 6" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        }
                        dropdownMatchSelectWidth={false}
                    >

                        {options.map((opt) => (
                            <Select.Option key={opt} value={opt}>
                                {opt}
                            </Select.Option>
                        ))}
                    </Select>
                );
            }
        }

        else if (inputType === "number") {
            inputNode = <Input type="number" />;
        }

        return (
            <td {...rest}>
                <Form.Item name={dataIndex} rules={rules} style={{ margin: 0 }}>
                    {inputNode}
                </Form.Item>
            </td>
        );
    };

    function formatNumber(num) {
        if (num === null || num === undefined) return "";

        const absNum = Math.abs(num);

        if (absNum >= 1e15) {
            return (num / 1e15).toFixed(1).replace(/\.0$/, "") + "Q";
        } else if (absNum >= 1e12) {
            return (num / 1e12).toFixed(1).replace(/\.0$/, "") + "T";
        } else if (absNum >= 1e9) {
            return (num / 1e9).toFixed(1).replace(/\.0$/, "") + "B";
        } else if (absNum >= 1e6) {
            return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
        } else if (absNum >= 1e3) {
            return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "K";
        } else {
            return num.toString();
        }
    }


    const handleDownload = async (type) => {
        // let status = Cookies.get("token_xapads_ssp") ? true : false;
        // if (status) {
        //     let token = Cookies.get("token_xapads_ssp");
        let typeData = type === "web" ? "website" : type === "ctv" ? "ctv" : "inapp"
        axios
            .get(
                configData.SERVER_URL +
                `user/downloadSample?type=` + typeData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        // "x-access-token": token,
                    },
                    responseType: "blob",
                }
            )
            .then((response) => {
                const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(blob, type + "_" + new Date().getTime() + ".xlsx");
            })
            .catch((error) => { });

    };



    const isIndeterminate = (colvis) => {
        const values = Object.values(colvis);
        return values.some(value => value) && !values.every(value => value);
    };


    const [colvisWeb, setColvisWeb] = useState({
        "ownerDomain": true,
        "risk": true,
        "rejectionReason": true,
        "ivtRate": true,
        "brandRiskFloorFree": true,
        "viewabilityRate": true,
        "mfaRisk": true,
        "impressionRange": true,
    })


    const [colvisMobile, setColvisMobile] = useState({
        "app_bundle": true,
        "app_store_url": true,
        "rejectionReason": true,
        "ivtRate": true,
        "brandRiskFloorFree": true,
        "viewabilityRate": true,
        // "mfaRisk": true,
        "impressionRange": true,
    })

    const [colvisCtv, setColvisCtv] = useState({
        "app_bundle": true,
        "app_store_url": true,
        "rejectionReason": true,
        "ivtRate": true,
        "brandRiskFloorFree": true,
        "viewabilityRate": true,
        // "mfaRisk": true,
        "impressionRange": true,
    })


    const [filterRepeaterValueOptions_colvisWeb] = useState([
        // { label: "Inventory Provider", value: "inventory_provider" },
        // { label: "Traffic Type", value: "traffic_type" },
        // { label: "Geo", value: "geo" },
        // { label: "Avg eCPM ($)", value: "avg_ecpm" },
        // { label: "Last 30 Avails", value: "last_30_avails" },
        // { label: "Publisher", value: "p_name" },
        { label: "Rejection Reason", value: "rejectionReason" },

    ])
    const [filterRepeaterValueOptions_colvisMobile] = useState([
        { label: "App Bundle", value: "app_bundle" },
        { label: "App Store URL", value: "app_store_url" },
        { label: "Rejection Reason", value: "rejectionReason" },
    ])

    const [filterRepeaterValueOptions_colvisMobileSupplyLens] = useState([
        { label: "IVT Rate", value: "ivtRate" },
        { label: "Brand Risk Floor Free", value: "brandRiskFloorFree" },
        { label: "Viewability", value: "viewabilityRate" },
        // { label: "MFA Risk", value: "mfaRisk" },
        { label: "Impression Range", value: "impressionRange" },
    ])

    const [filterRepeaterValueOptions_colvisCtv] = useState([
        { label: "App Bundle", value: "app_bundle" },
        { label: "App Store URL", value: "app_store_url" },
        { label: "Rejection Reason", value: "rejectionReason" },
    ])

    const [filterRepeaterValueOptions_colvisCtvSupplyLens] = useState([
        { label: "IVT Rate", value: "ivtRate" },
        { label: "Brand Risk Floor Free", value: "brandRiskFloorFree" },
        { label: "Viewability", value: "viewabilityRate" },
        // { label: "MFA Risk", value: "mfaRisk" },
        { label: "Impression Range", value: "impressionRange" },
    ])



    const [filterRepeaterValueOptions_colvisWebSupplyLens] = useState([
        { label: "IVT Rate", value: "ivtRate" },
        { label: "Brand Risk Floor Free", value: "brandRiskFloorFree" },
        { label: "Viewability", value: "viewabilityRate" },
        { label: "MFA Risk", value: "mfaRisk" },
        { label: "Impression Range", value: "impressionRange" },
    ])


    //-----adstxt related modal starts------------------------------//

    const [isModalVisibleAdsTxt, setIsModalVisibleAdstxt] = useState(false);

    //with value
    // {
    //     name: "plex.tv",
    //         totalLines: 10,
    //             missingLines: 6,
    //                 authoredLinesCount: 4,
    //                     authoredLines: [
    //                         "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                         "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                         "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                         "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN"
    //                     ],
    //                         missingLinesTop: [
    //                             "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                             "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                         ],
    //                             missingLinesDirect: [
    //                                 "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                                 "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                                 "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                                 "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                             ],
    //                                 lastCrawledDate: "13/01/2026",
    //                                     lastCrawledTime: "03:18:08AM UTC",
    // }

    //without value
    // {
    //     name: "plex.tv",
    //         totalLines: 10,
    //             missingLines: 10,
    //                 authoredLinesCount: 0,
    //                     authoredLines: []
    //                         ,
    //                         missingLinesTop: [
    //                             "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                             "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                             "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                             "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                             "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                             "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                         ],
    //                             missingLinesDirect: [
    //                                 "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                                 "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                                 "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                                 "lijit.com, 585769, DIRECT, fafdf38b16bf6b2b #SOVRN",
    //                             ],
    //                                 lastCrawledDate: "13/01/2026",
    //                                     lastCrawledTime: "03:18:08AM UTC",
    //     }


    // const formatLastCrawledPST = (date, time) => {
    //     // Handle null, undefined, or empty string for either field
    //     if (!date || !time || date.trim() === "" || time.trim() === "") {
    //         return null;
    //     }

    //     try {
    //         // Parse DD/MM/YYYY
    //         const [day, month, year] = date.split("/");
    //         if (!day || !month || !year) return null;

    //         // Normalize time: "0:14:48 pm UTC" → standard parseable format
    //         // Remove " UTC" suffix, then parse as 12-hour time
    //         const timeCleaned = time.replace(/\s*UTC\s*/i, "").trim(); // "0:14:48 pm"

    //         // Build an ISO-like string using UTC
    //         // Use en-US locale parsing trick via Date constructor
    //         const dateTimeStr = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")} ${timeCleaned}`;
    //         const parsed = new Date(dateTimeStr + " UTC");

    //         if (isNaN(parsed.getTime())) return null;

    //         // Format in PST (America/Los_Angeles handles PST/PDT automatically)
    //         return parsed.toLocaleString("en-US", {
    //             timeZone: "America/Los_Angeles",
    //             month: "short",
    //             day: "numeric",
    //             year: "numeric",
    //             hour: "numeric",
    //             minute: "2-digit",
    //             hour12: true,
    //             timeZoneName: "short", // shows "PST" or "PDT"
    //         });
    //     } catch {
    //         return null;
    //     }
    // };

    const formatLastCrawledPST = (date, time) => {
        if (!date || !time || date.trim() === "" || time.trim() === "") {
            return null;
        }

        try {
            const [day, month, year] = date.split("/");
            if (!day || !month || !year) return null;

            const dayNum = Number(day);
            const monthNum = Number(month);
            const yearNum = Number(year);
            if (!Number.isInteger(dayNum) || !Number.isInteger(monthNum) || !Number.isInteger(yearNum)) return null;

            // Parse UTC time in a Safari-safe way (no Date string parsing).
            const timeCleaned = time.replace(/\s*UTC\s*/i, "").trim(); // e.g. "0:14:48 pm" or "03:18:08AM"
            if (!timeCleaned) return null;

            const timeMatch = timeCleaned.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*([aApP][mM])$/);
            if (!timeMatch) return null;

            const rawHour = Number(timeMatch[1]);
            const minute = Number(timeMatch[2]);
            const second = Number(timeMatch[3] || "0");
            const meridiem = timeMatch[4].toUpperCase();

            if (
                !Number.isInteger(rawHour) || !Number.isInteger(minute) || !Number.isInteger(second) ||
                rawHour < 0 || rawHour > 12 || minute < 0 || minute > 59 || second < 0 || second > 59
            ) {
                return null;
            }

            // Treat "0:xx am/pm" as "12:xx am/pm" to support legacy API values.
            const normalizedHour12 = rawHour === 0 ? 12 : rawHour;
            if (normalizedHour12 < 1 || normalizedHour12 > 12) return null;

            let hour24 = normalizedHour12 % 12;
            if (meridiem === "PM") hour24 += 12;

            const parsed = new Date(Date.UTC(yearNum, monthNum - 1, dayNum, hour24, minute, second));

            if (isNaN(parsed.getTime())) return null;

            // Get date parts in PST
            const parts = new Intl.DateTimeFormat("en-GB", {
                timeZone: "America/Los_Angeles",
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            }).formatToParts(parsed);

            const p = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
            const formattedDate = `${p.day}/${p.month}/${p.year}`; // DD/MM/YYYY

            // Get time parts in PST (12-hour)
            const timeParts = new Intl.DateTimeFormat("en-US", {
                timeZone: "America/Los_Angeles",
                hour: "numeric",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
            }).formatToParts(parsed);

            const t = Object.fromEntries(timeParts.map(({ type, value }) => [type, value]));
            const formattedTime = `${t.hour}:${t.minute}:${t.second} ${t.dayPeriod.toLowerCase()}`; // 0:14:48 pm

            return (
                <>
                    {formattedDate} <span className="at_text">at</span> {formattedTime} PST
                </>
            )
        } catch {
            return null;
        }
    };


    const [modalVisibleAdsTxtData, setModalVisibleAdstxtData] = useState(
        {
            name: "",
            totalLines: 0,
            missingLines: 0,
            authoredLinesCount: 0,
            authoredLines: []
            ,
            missingLinesTop: [
            ],
            missingLinesDirect: [

            ],
            lastCrawledDate: "",
            lastCrawledTime: "",
        });

    const resetModalAdstxt = () => {
        setIsModalVisibleAdstxt(false)
        setModalVisibleAdstxtData(
            {
                name: "",
                totalLines: 0,
                missingLines: 0,
                authoredLinesCount: 0,
                authoredLines: []
                ,
                missingLinesTop: [
                ],
                missingLinesDirect: [

                ],
                lastCrawledDate: "",
                lastCrawledTime: "",
            });
        setIsShowAdstxtTab(false)
        setActiveAdstxtTab("direct")
    };
    const closeModalAdstxt = () => {
        resetModalAdstxt()
    };

    const [isShowAdstxtTab, setIsShowAdstxtTab] = useState(false);
    const [activeAdstxtTab, setActiveAdstxtTab] = useState("direct");

    const hideShowAdstxtTab = () => {
        setIsShowAdstxtTab(togg => !togg)
    };

    const handleActiveAdstxttab = (event) => {
        setActiveAdstxtTab(event.target.value)
    };



    const [tooltipContent, setTooltipContent] = useState("Click to copy")

    function copyToClipboard(text) {

        // ✅ If it's an array → convert to line-separated string
        const finalText = Array.isArray(text) ? text.join("\n") : text;

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(finalText)
                .catch((error) => {
                    console.error("Unable to copy:", error);
                });
        } else {
            var tempInput = document.createElement("textarea"); // ✅ use textarea (better for multiline)
            tempInput.value = finalText;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand("copy");
            document.body.removeChild(tempInput);
        }

        setTooltipContent("Copied");

        setTimeout(() => {
            setTooltipContent("Click to copy");
        }, 1000);
    }

    function downloadTxtFile(data, fileName = "ads.txt") {
        // Convert array to line-separated string
        const finalText = Array.isArray(data) ? data.join("\n") : data;

        const blob = new Blob([finalText], {
            type: "text/plain;charset=utf-8;",
        });

        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        link.href = url;
        link.download = fileName.endsWith(".txt")
            ? fileName
            : `${fileName}.txt`;

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }



    //-----adstxt related modal ends----------------------------------//



    const columnsWebsite = [
        {
            title: '',
            // dataIndex: 'action',
            key: 'action',
            fixed: 'left',
            className: (checkRole === "admin" || checkRole === "u_admin") ? '' : 'ps-0',
            width: (checkRole === "admin" || checkRole === "u_admin") ? 85 : 70,
            onHeaderCell: () => ({
                className: (checkRole === "admin" || checkRole === "u_admin") ? 'border_right_0' : 'border_right_0 ps-0',
            }),
            render: (_, record) => {
                const editable = isEditing(record);
                return (
                    <div className="">
                        {editable ? (
                            <div className="d-flex gap-2">
                                <Typography.Link onClick={(e) => {
                                    e.stopPropagation();
                                    save(record._id);
                                }}>
                                    <Tooltip title="Save">
                                        <div className='d-flex align-items-center' style={{ gap: '0.6rem' }}>
                                            <div className='div_of_icon --save_icon_div cursor_pointer'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <path d="M11.6663 3.5L5.24967 9.91667L2.33301 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                        </div>
                                    </Tooltip>

                                </Typography.Link>
                                <Typography.Link onClick={(e) => {
                                    e.stopPropagation();
                                    cancel();
                                }}>
                                    <Tooltip title="Cancel">
                                        <div className='d-flex align-items-center' style={{ gap: '0.6rem' }}>
                                            <div className='div_of_icon --cancel_icon_div cursor_pointer'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <path d="M10.5 3.5L3.5 10.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M3.5 3.5L10.5 10.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                        </div>
                                    </Tooltip>

                                </Typography.Link>
                            </div>
                        ) : (
                            <Tooltip title="Edit">
                                <div className='download_icon download_icon_d2 text-center'
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        edit(record);
                                    }}>
                                    <img src={Edit} alt="" className='img-fluid cursor_pointer' />
                                </div>
                            </Tooltip>
                        )}

                    </div >
                )
            }
        },
        {
            title: 'Status',
            // dataIndex: 'action',
            key: 'status',
            fixed: 'left',
            className: (checkRole === "admin" || checkRole === "u_admin") ? '' : 'ps-0',
            width: (checkRole === "admin" || checkRole === "u_admin") ? 160 : 100,
            onHeaderCell: () => ({
                className: (checkRole === "admin" || checkRole === "u_admin") ? 'border_right_0' : 'border_right_0 ps-0',
            }),
            render: (_, record) => {
                const editable = isEditing(record);
                return (
                    <div className="d-flex gap-2">

                        {(checkRole !== "admin" && checkRole !== "u_admin") && !editable &&
                            <>

                                {record.status === "pending" ?
                                    <div className='btn_group --btn_group_select' style={{ width: '80%' }}>
                                        <div onClick={() => statusChange("approved", [record._id], "")}>
                                            <Tooltip title='Approve'>
                                                <button className='btn_outline_success btn --diff_clr_of_approved_box'>
                                                    <img src={checkIcon} alt='USP' />
                                                </button>
                                            </Tooltip>
                                        </div>

                                        <div >
                                            <Tooltip title='Reject'>

                                                <Select
                                                    value="Reject"
                                                    suffixIcon={null}   // 👈 default arrow remove
                                                    labelRender={(label) => (
                                                        <span className="reject_label">
                                                            <img src={crossIcon} alt="Reject" />
                                                        </span>
                                                    )}
                                                    dropdownMatchSelectWidth={false}
                                                    // style={{ width: 140 }}
                                                    // open={true}
                                                    className="reject_select"
                                                    onChange={(event) => { statusChange("rejected", [record._id], event) }}
                                                    dropdownRender={(menu) => (
                                                        <>
                                                            <div className="select_dropdown_header">
                                                                Please specify the reason of rejection
                                                            </div>
                                                            {menu}
                                                        </>
                                                    )}
                                                    options={rejectionOptions}
                                                />
                                            </Tooltip>
                                        </div>
                                    </div>
                                    :
                                    <div className={record.status === "approved" ? "case_select_tag" : "case_select_tag --rejected_cascader"}>
                                        <Cascader
                                            options={rejectionOptionsCascader}
                                            placeholder=""
                                            // open={true}
                                            // dropdownAlign={{
                                            //     points: ['tl', 'bl'],
                                            //     overflow: {
                                            //         adjustX: false,
                                            //         adjustY: false, // ❌ auto upar le jana band
                                            //     },
                                            // }}
                                            allowClear={false}
                                            value={
                                                record.status === "approved"
                                                    ? ["Approved"]
                                                    : record.status === "rejected" && record.rejectionReason
                                                        ? ["Rejected", record.rejectionReason]
                                                        : ["Rejected"]
                                            }
                                            // defaultValue='Approved'
                                            // open={true}
                                            popupClassName="reject_reason_popover"
                                            onChange={(value) => handleStatusChange(value, record)}
                                            style={{ width: 'auto' }}
                                            displayRender={(labels) => labels[0]} // ✅ sirf parent show
                                            suffixIcon={null}
                                            expandIcon={
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M6.0016 12.655C5.82827 12.655 5.66159 12.5883 5.52825 12.4617C5.26825 12.2017 5.26825 11.7817 5.52825 11.5217L9.05494 7.99502L5.52825 4.46835C5.26825 4.20835 5.26825 3.78834 5.52825 3.52834C5.78825 3.26834 6.20827 3.26834 6.46827 3.52834L10.4683 7.52834C10.7283 7.78834 10.7283 8.20835 10.4683 8.46835L6.46827 12.4683C6.33494 12.6017 6.16826 12.6617 5.99493 12.6617L6.0016 12.655Z" fill="#98A2B3" />
                                                </svg>
                                            }
                                        />
                                    </div>
                                }
                            </>
                        }
                        {(checkRole === "admin" || checkRole === "u_admin") && !editable &&
                            <div>
                                <Select
                                    className={`form_select badge_content--${record.status?.toLowerCase() === "pending" ? "new" : record.status?.toLowerCase()}`}
                                    dropdownStyle={{
                                        width: '14rem'
                                    }}
                                    style={{ pointerEvents: "none" }}
                                    value={record?.status}
                                    options={
                                        [{ label: "Approved", value: "approved" }, { label: "Rejected", value: "rejected" }, { label: "Pending", value: "pending" }]

                                    }
                                />
                            </div>
                        }
                    </div >
                )
            }
        },
        {
            title: "Domain",
            dataIndex: "domain",
            key: "domain",
            width: 160,
            sorter: true,
            fixed: 'left',
            sortDirections: ['ascend', 'descend', 'ascend'],
            onHeaderCell: () => ({
                className: "border_right_0",
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <a href={value.includes("https://") ? value : "https://" + value} target="_blank" rel="noreferrer" className='text_primary' >{value}</a>

                );
            }
        },

        {
            title: 'ads.txt',
            dataIndex: 'adstxtChecking',
            key: 'adstxtChecking',
            sorter: false,
            fixed: 'left',
            width: 80,
            onHeaderCell: () => ({
                className: 'text-end',
            }),
            render: (_, record) => {
                return (
                    <div className='d-flex align-items-center justify-content-end w-100'>
                        <div className='sheetbadgearea'
                            onClick={() => {
                                if (record.adstxtChecking !== undefined && record.adstxtChecking !== null && record.adstxtChecking !== "" && record.adstxtChecking === false) {
                                    setIsModalVisibleAdstxt(true)
                                    setModalVisibleAdstxtData(record.adstxtData)
                                }
                            }}
                        >

                            {/* for number */}

                            {
                                !(record.adstxtChecking === undefined || record.adstxtChecking === null || record.adstxtChecking === "" || record.adstxtChecking === false) ?
                                    <>
                                        <Tooltip title="We are checking ads.txt file. Please check back later.">
                                            {/* for tooltip */}
                                            <div className='sheetbadgediv --yellow_badge'>

                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                    <path d="M5 5L2.625 3.21875C2.58641 3.18943 2.55507 3.15165 2.5334 3.1083C2.51173 3.06496 2.5003 3.01721 2.5 2.96875V1.5625C2.5 1.47962 2.53292 1.40013 2.59153 1.34153C2.65013 1.28292 2.72962 1.25 2.8125 1.25H7.1875C7.27038 1.25 7.34987 1.28292 7.40847 1.34153C7.46708 1.40013 7.5 1.47962 7.5 1.5625V2.95312C7.4997 3.00159 7.48828 3.04933 7.4666 3.09268C7.44493 3.13602 7.41359 3.17381 7.375 3.20312L5 5Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M5 5L2.625 6.78125C2.58641 6.81057 2.55507 6.84835 2.5334 6.8917C2.51173 6.93504 2.5003 6.98279 2.5 7.03125V8.4375C2.5 8.52038 2.53292 8.59987 2.59153 8.65847C2.65013 8.71708 2.72962 8.75 2.8125 8.75H7.1875C7.27038 8.75 7.34987 8.71708 7.40847 8.65847C7.46708 8.59987 7.5 8.52038 7.5 8.4375V7.04687C7.4997 6.99841 7.48828 6.95067 7.4666 6.90732C7.44493 6.86398 7.41359 6.82619 7.375 6.79688L5 5Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>

                                            </div>
                                        </Tooltip>
                                    </>
                                    :
                                    <>
                                        <div className={record.adstxtLineCount !== 0 ? 'sheetbadgediv ' : 'sheetbadgediv --red_badge'}

                                        >
                                            <span>{record.adstxtLineCount}</span>
                                        </div>

                                    </>


                            }

                            <img src={SheetIcon} alt='' />
                        </div >
                    </div>
                )
            }
        },

        {
            title: "Publisher",
            dataIndex: "p_name",
            key: "p_name",
            width: 180,
            // hidden: !colvisWeb["p_name"] || (checkRole === "admin" || checkRole === "u_admin"),
            hidden: (checkRole === "admin" || checkRole === "u_admin"),
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            // fixed: 'left',
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value, record) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{record.adk_id}-{value}</>

                );
            }
        },
        // {
        //     title: "Owner Domain",
        //     dataIndex: ["pixalate", "domainInfo", "ownerDomain"],
        //     key: "ownerDomain",
        //     width: 200,
        //     hidden: !colvisWeb["ownerDomain"],
        //     onHeaderCell: () => ({
        //         className: 'border_right_0',
        //     }),
        //     render: (value, record) => {
        //         // 🚧 Under Processing state (same as IVT)
        //         if (!record.isMRTData) {
        //             return (
        //                 <Tooltip title="Under Processing">
        //                     <div className="loader_icon">
        //                         <span className="--icon"></span>
        //                         <span className="--icon"></span>
        //                         <span className="--icon"></span>
        //                     </div>
        //                 </Tooltip>
        //             );
        //         }

        //         // ✅ Data available
        //         if (value === null || value === undefined) return "-";

        //         // Optional: if API returns array
        //         // if (Array.isArray(value)) {
        //         //     return value.length ? value.join(", ") : "-";
        //         // }

        //         return value;
        //     },
        // },
        // {
        //     title: "Risk",
        //     dataIndex: ["pixalate", "riskMetrics", "risk"],
        //     key: "risk",
        //     hidden: !colvisWeb["risk"],
        //     width: 110,
        //     onHeaderCell: () => ({
        //         className: 'border_right_0',
        //     }),
        //     render: (value, record) => {

        //         if (!record.isMRTData) {
        //             return (
        //                 <Tooltip title="Under Processing">
        //                     <div className="loader_icon">
        //                         <span className="--icon"></span>
        //                         <span className="--icon"></span>
        //                         <span className="--icon"></span>
        //                     </div>
        //                 </Tooltip>
        //             );
        //         }

        //         if (value === null || value === undefined || value === "") return "-";

        //         if (value === "NA") return "NA";

        //         return (
        //             <>
        //                 <div className='d-flex gap-3'>
        //                     {value === "low" ? <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        //                         <rect width="3" height="16" rx="1.5" fill="#0EA371" />
        //                         <rect x="6" width="3" height="16" rx="1.5" fill="#EAECF0" />
        //                         <rect x="12" width="3" height="16" rx="1.5" fill="#EAECF0" />
        //                     </svg>
        //                         :
        //                         value === "medium" ?
        //                             <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        //                                 <rect width="3" height="16" rx="1.5" fill="#FF8800" />
        //                                 <rect x="6" width="3" height="16" rx="1.5" fill="#FF8800" />
        //                                 <rect x="12" width="3" height="16" rx="1.5" fill="#EAECF0" />
        //                             </svg>

        //                             :
        //                             <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        //                                 <rect width="3" height="16" rx="1.5" fill="#D92D20" />
        //                                 <rect x="6" width="3" height="16" rx="1.5" fill="#D92D20" />
        //                                 <rect x="12" width="3" height="16" rx="1.5" fill="#D92D20" />
        //                             </svg>

        //                     }

        //                     {value}
        //                 </div>
        //             </>

        //         );
        //     }
        // },
        {
            title: "Inventory Provider",
            dataIndex: "inventory_provider",
            key: "inventory_provider",
            width: 160,
            sorter: true,
            // hidden: !colvisWeb["inventory_provider"],
            sortDirections: ['ascend', 'descend', 'ascend'],
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{value}</>

                );
            }
        },

        {
            title: "Traffic Type",
            dataIndex: "traffic_type",
            key: "traffic_type",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 140,
            // hidden: !colvisWeb["traffic_type"],
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <div style={{ textTransform: "lowercase" }}>{value}</div>

                );
            }
        },
        {
            title: "Geo",
            dataIndex: "geo",
            key: "geo",
            width: 200,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            // width: 130,
            // hidden: !colvisWeb["geo"],
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                const country = countryOptions.find(c => c.value === value);
                return country ? country.label : value;
            }
        },
        {
            title: "Avg eCPM ($)",
            dataIndex: "avg_ecpm",
            key: "avg_ecpm",
            sorter: true,
            // hidden: !colvisWeb["avg_ecpm"],
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 110,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{value}</>

                );
            }
        },
        {
            title: "Last 30 Avails",
            dataIndex: "last_30_avails",
            key: "last_30_avails",
            width: 130,
            sorter: true,
            // hidden: !colvisWeb["last_30_avails"],
            sortDirections: ['ascend', 'descend', 'ascend'],
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{formatNumber(value)}</>

                );
            }
        },
        {
            title: "Rejection Reason",
            dataIndex: "rejectionReason",
            key: "rejectionReason",
            hidden: !colvisWeb["rejectionReason"],
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 120,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined || value === "") return "-";

                if (value === "NA") return "NA";

                return (
                    <>{value}</>

                );
            }
        },
        {
            title: "Supply Lens",
            key: "supplyLens",
            onHeaderCell: () => ({
                className: 'diff_border_line_clr',
            }),
            hidden: !(
                colvisWeb.ivtRate ||
                colvisWeb.brandRiskFloorFree ||
                colvisWeb.viewabilityRate ||
                colvisWeb.mfaRisk ||
                colvisWeb.impressionRange
            ),
            children: [
                {
                    title: "IVT Rate",
                    dataIndex: "ivtRate",
                    key: "ivtRate",
                    width: 120,
                    hidden: !colvisWeb["ivtRate"],
                    onHeaderCell: () => ({
                        className: 'border_right_ts',
                    }),
                    render: (value) => {
                        if (value === null || value === undefined) return "-";
                        return value;
                    },
                },
                {
                    title: "Brand Risk Floor Free",
                    dataIndex: "brandRiskFloorFree",
                    key: "brandRiskFloorFree",
                    width: 170,
                    hidden: !colvisWeb["brandRiskFloorFree"],
                    onHeaderCell: () => ({
                        className: 'border_right_ts',
                    }),
                    render: (value) => {
                        if (value === null || value === undefined) return "-";
                        return value;
                    },
                },
                {
                    title: "Viewability",
                    dataIndex: "viewabilityRate",
                    key: "viewabilityRate",
                    width: 120,
                    hidden: !colvisWeb["viewabilityRate"],
                    onHeaderCell: () => ({
                        className: 'border_right_ts',
                    }),
                    render: (value) => {
                        if (value === null || value === undefined) return "-";
                        return value;
                    },
                },
                {
                    title: "MFA Risk",
                    dataIndex: "mfaRisk",
                    key: "mfaRisk",
                    width: 120,
                    hidden: !colvisWeb["mfaRisk"],
                    onHeaderCell: () => ({
                        className: 'border_right_ts',
                    }),
                    render: (value) => {
                        if (value === null || value === undefined) return "-";
                        return value;
                    },
                },
                {
                    title: "Impression Range",
                    dataIndex: "impressionRange",
                    key: "impressionRange",
                    width: 140,
                    hidden: !colvisWeb["impressionRange"],
                    render: (value) => {
                        if (value === null || value === undefined) return "-";
                        return value;
                    },
                },
            ]
        },

    ]

    const mergedColumnsWebsite = columnsWebsite.map((col) => {
        // 🚨 Skip columns without dataIndex
        if (!col.dataIndex) return col;

        const meta = inventoryTemplates.Website[col.dataIndex];

        if (!meta || !editableFieldsByType.web.includes(col.dataIndex)) {
            return col;
        }

        return {
            ...col,
            // onCell: (record) => ({
            //     record,
            //     dataIndex: col.dataIndex,
            //     inputType: meta.type,
            //     options: meta.options || [],
            //     rules: buildRules(meta),
            //     editing: isEditing(record),
            // }),
            onCell: (record) => ({
                record,
                dataIndex: col.dataIndex,
                inputType: meta.type,
                options:
                    col.dataIndex === "geo"
                        ? countryOptions
                        : meta.options || [],
                rules: buildRules(meta),
                editing: isEditing(record),
            }),
        };
    });


    const columnsCTV = [
        {
            title: '',
            // dataIndex: 'action',
            key: 'action',
            fixed: 'left',
            className: (checkRole === "admin" || checkRole === "u_admin") ? '' : 'ps-0',
            width: (checkRole === "admin" || checkRole === "u_admin") ? 85 : 70,
            onHeaderCell: () => ({
                className: (checkRole === "admin" || checkRole === "u_admin") ? 'border_right_0' : 'border_right_0 ps-0',
            }),
            render: (_, record) => {
                const editable = isEditing(record);
                return (
                    <>
                        <div className="">
                            {editable ? (
                                <div className="d-flex gap-2">
                                    <Typography.Link onClick={(e) => {
                                        e.stopPropagation();
                                        save(record._id);
                                    }}>
                                        <Tooltip title="Save">
                                            <div className='d-flex align-items-center' style={{ gap: '0.6rem' }}>
                                                <div className='div_of_icon --save_icon_div cursor_pointer'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <path d="M11.6663 3.5L5.24967 9.91667L2.33301 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </Tooltip>

                                    </Typography.Link>
                                    <Typography.Link onClick={(e) => {
                                        e.stopPropagation();
                                        cancel();
                                    }}>
                                        <Tooltip title="Cancel">
                                            <div className='d-flex align-items-center' style={{ gap: '0.6rem' }}>
                                                <div className='div_of_icon --cancel_icon_div cursor_pointer'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <path d="M10.5 3.5L3.5 10.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M3.5 3.5L10.5 10.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </Tooltip>

                                    </Typography.Link>
                                </div>
                            ) : (
                                <Tooltip title="Edit">
                                    <div className='download_icon download_icon_d2 text-center'
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            edit(record);
                                        }}>
                                        <img src={Edit} alt="" className='img-fluid cursor_pointer' />
                                    </div>
                                </Tooltip>
                            )}

                        </div >
                    </>
                )
            }
        },

        {
            title: 'Status',
            // dataIndex: 'action',
            key: 'status',
            fixed: 'left',
            className: (checkRole === "admin" || checkRole === "u_admin") ? '' : 'ps-0',
            width: (checkRole === "admin" || checkRole === "u_admin") ? 160 : 100,
            onHeaderCell: () => ({
                className: (checkRole === "admin" || checkRole === "u_admin") ? 'border_right_0' : 'border_right_0 ps-0',
            }),
            render: (_, record) => {
                const editable = isEditing(record);
                return (
                    <div className="d-flex gap-2">

                        {(checkRole !== "admin" && checkRole !== "u_admin") && !editable &&
                            <>

                                {record.status === "pending" ?
                                    <div className='btn_group --btn_group_select' style={{ width: '80%' }}>
                                        <div onClick={() => statusChange("approved", [record._id], "")}>
                                            <Tooltip title='Approve'>
                                                <button className='btn_outline_success btn --diff_clr_of_approved_box'>
                                                    <img src={checkIcon} alt='USP' />
                                                </button>
                                            </Tooltip>
                                        </div>

                                        <div >
                                            <Tooltip title='Reject'>
                                                <Select
                                                    value="Reject"
                                                    suffixIcon={null}   // 👈 default arrow remove
                                                    labelRender={(label) => (
                                                        <span className="reject_label">
                                                            <img src={crossIcon} alt="Reject" />
                                                        </span>
                                                    )}
                                                    dropdownMatchSelectWidth={false}
                                                    // style={{ width: 140 }}
                                                    className="reject_select"
                                                    onChange={(event) => { statusChange("rejected", [record._id], event) }}
                                                    dropdownRender={(menu) => (
                                                        <>
                                                            <div className="select_dropdown_header">
                                                                Please specify the reason of rejection
                                                            </div>
                                                            {menu}
                                                        </>
                                                    )}
                                                    options={rejectionOptionsCtv}
                                                />
                                            </Tooltip>
                                        </div>
                                    </div>
                                    :
                                    <div className={record.status === "approved" ? "case_select_tag" : "case_select_tag --rejected_cascader"}>
                                        <Cascader
                                            options={rejectionOptionsCascaderCtv}
                                            placeholder=""
                                            // open={true}
                                            // dropdownAlign={{
                                            //     points: ['tl', 'bl'],
                                            //     overflow: {
                                            //         adjustX: false,
                                            //         adjustY: false, // ❌ auto upar le jana band
                                            //     },
                                            // }}
                                            allowClear={false}
                                            value={
                                                record.status === "approved"
                                                    ? ["Approved"]
                                                    : record.status === "rejected" && record.rejectionReason
                                                        ? ["Rejected", record.rejectionReason]
                                                        : ["Rejected"]
                                            }
                                            // defaultValue='Approved'
                                            // open={true}
                                            popupClassName="reject_reason_popover"
                                            onChange={(value) => handleStatusChange(value, record)}
                                            style={{ width: 'auto' }}
                                            displayRender={(labels) => labels[0]} // ✅ sirf parent show
                                            suffixIcon={null}
                                            expandIcon={
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M6.0016 12.655C5.82827 12.655 5.66159 12.5883 5.52825 12.4617C5.26825 12.2017 5.26825 11.7817 5.52825 11.5217L9.05494 7.99502L5.52825 4.46835C5.26825 4.20835 5.26825 3.78834 5.52825 3.52834C5.78825 3.26834 6.20827 3.26834 6.46827 3.52834L10.4683 7.52834C10.7283 7.78834 10.7283 8.20835 10.4683 8.46835L6.46827 12.4683C6.33494 12.6017 6.16826 12.6617 5.99493 12.6617L6.0016 12.655Z" fill="#98A2B3" />
                                                </svg>
                                            }
                                        />
                                    </div>
                                }
                            </>
                        }
                        {(checkRole === "admin" || checkRole === "u_admin") && !editable &&
                            <div>
                                <Select
                                    className={`form_select badge_content--${record.status?.toLowerCase() === "pending" ? "new" : record.status?.toLowerCase()}`}
                                    dropdownStyle={{
                                        width: '14rem'
                                    }}
                                    style={{ pointerEvents: "none" }}
                                    value={record?.status}
                                    options={
                                        [{ label: "Approved", value: "approved" }, { label: "Rejected", value: "rejected" }, { label: "Pending", value: "pending" }]

                                    }
                                />
                            </div>
                        }
                    </div >
                )
            }
        },
        {
            title: "App Name",
            dataIndex: "app_name",
            key: "app_name",
            width: 180,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            fixed: 'left',
            onHeaderCell: () => ({
                className: "border_right_0",
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{value}</>

                );
            }
        },

        {
            title: 'ads.txt',
            dataIndex: 'adstxtChecking',
            key: 'adstxtChecking',
            sorter: false,
            fixed: 'left',
            width: 80,
            onHeaderCell: () => ({
                className: 'text-end',
            }),
            render: (_, record) => {
                return (
                    <div className='d-flex align-items-center justify-content-end w-100'>
                        <div className='sheetbadgearea'
                            onClick={() => {
                                if (record.adstxtChecking !== undefined && record.adstxtChecking !== null && record.adstxtChecking !== "" && record.adstxtChecking === false) {
                                    setIsModalVisibleAdstxt(true)
                                    setModalVisibleAdstxtData(record.adstxtData)
                                }
                            }}
                        >

                            {/* for number */}

                            {
                                !(record.adstxtChecking === undefined || record.adstxtChecking === null || record.adstxtChecking === "" || record.adstxtChecking === false) ?
                                    <>
                                        <Tooltip title="We are checking ads.txt file. Please check back later.">
                                            {/* for tooltip */}
                                            <div className='sheetbadgediv --yellow_badge'>

                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                    <path d="M5 5L2.625 3.21875C2.58641 3.18943 2.55507 3.15165 2.5334 3.1083C2.51173 3.06496 2.5003 3.01721 2.5 2.96875V1.5625C2.5 1.47962 2.53292 1.40013 2.59153 1.34153C2.65013 1.28292 2.72962 1.25 2.8125 1.25H7.1875C7.27038 1.25 7.34987 1.28292 7.40847 1.34153C7.46708 1.40013 7.5 1.47962 7.5 1.5625V2.95312C7.4997 3.00159 7.48828 3.04933 7.4666 3.09268C7.44493 3.13602 7.41359 3.17381 7.375 3.20312L5 5Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M5 5L2.625 6.78125C2.58641 6.81057 2.55507 6.84835 2.5334 6.8917C2.51173 6.93504 2.5003 6.98279 2.5 7.03125V8.4375C2.5 8.52038 2.53292 8.59987 2.59153 8.65847C2.65013 8.71708 2.72962 8.75 2.8125 8.75H7.1875C7.27038 8.75 7.34987 8.71708 7.40847 8.65847C7.46708 8.59987 7.5 8.52038 7.5 8.4375V7.04687C7.4997 6.99841 7.48828 6.95067 7.4666 6.90732C7.44493 6.86398 7.41359 6.82619 7.375 6.79688L5 5Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>

                                            </div>
                                        </Tooltip>
                                    </>
                                    :
                                    <>
                                        <div className={record.adstxtLineCount !== 0 ? 'sheetbadgediv ' : 'sheetbadgediv --red_badge'}

                                        >
                                            <span>{record.adstxtLineCount}</span>
                                        </div>

                                    </>


                            }

                            <img src={SheetIcon} alt='' />
                        </div >
                    </div>
                )
            }
        },

        {
            title: "Publisher",
            dataIndex: "p_name",
            key: "p_name",
            width: 180,
            sorter: true,
            hidden: (checkRole === "admin" || checkRole === "u_admin"),
            sortDirections: ['ascend', 'descend', 'ascend'],
            // fixed: 'left',
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value, record) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{record.adk_id}-{value}</>

                );
            }
        },
        {
            title: "Store",
            dataIndex: "store",
            key: "store",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 180,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{value}</>

                );
            }
        },
        {
            title: "Inventory Provider",
            dataIndex: "inventory_provider",
            key: "inventory_provider",
            width: 180,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{value}</>

                );
            }
        },
        {
            title: "App Bundle",
            dataIndex: "app_bundle",
            key: "app_bundle",
            sorter: true,
            hidden: !colvisCtv["app_bundle"],
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 180,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{value}</>

                );
            }
        },
        {
            title: "App Store URL",
            dataIndex: "app_store_url",
            key: "app_store_url",
            sorter: true,
            hidden: !colvisCtv["app_store_url"],
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 180,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";
                if (value === "NA") return "NA";

                const text = String(value);
                const isLong = text.length > 30;
                const href = text.includes("https://") ? text : `https://${text}`;

                const link = (
                    <a
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                        className="text_primary"
                    >
                        {isLong ? `${text.slice(0, 30)}...` : text}
                    </a>
                );

                return isLong ? (
                    <Tooltip title={text} placement="top">
                        {link}
                    </Tooltip>
                ) : (
                    link
                );
            }
        },
        {
            title: "App-ads.txt URL",
            dataIndex: "app_ads_txt_url",
            key: "app_ads_txt_url",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 180,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";
                if (value === "NA") return "NA";

                const text = String(value);
                const isLong = text.length > 30;
                const href = text.includes("https://") ? text : `https://${text}`;

                const link = (
                    <a
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                        className="text_primary"
                    >
                        {isLong ? `${text.slice(0, 30)}...` : text}
                    </a>
                );

                return isLong ? (
                    <Tooltip title={text} placement="top">
                        {link}
                    </Tooltip>
                ) : (
                    link
                );
            }
        },
        {
            title: "Inventory Partner URL",
            dataIndex: "inventory_partner_domain",
            key: "inventory_partner_domain",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 180,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <a href={value.includes("https://") ? value : "https://" + value} target="_blank" rel="noreferrer" className='text_primary' >{value}</a>

                );
            }
        },
        {
            title: "Geo",
            dataIndex: "geo",
            key: "geo",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 200,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                const country = countryOptions.find(c => c.value === value);
                return country ? country.label : value;
            }
        },
        {
            title: "Avg eCPM ($)",
            dataIndex: "avg_ecpm",
            key: "avg_ecpm",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 100,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{value}</>

                );
            }
        },
        {
            title: "Last 30 Avails",
            dataIndex: "last_30_avails",
            key: "last_30_avails",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 130,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{formatNumber(value)}</>

                );
            }
        },
        {
            title: "Rejection Reason",
            dataIndex: "rejectionReason",
            key: "rejectionReason",
            sorter: true,
            hidden: !colvisCtv["rejectionReason"],
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 120,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined || value === "") return "-";

                if (value === "NA") return "NA";

                return (
                    <>{value}</>

                );
            }
        },
        {
            title: "Supply Lens",
            key: "supplyLensCtv",
            onHeaderCell: () => ({
                className: 'diff_border_line_clr',
            }),
            hidden: !(
                colvisCtv.ivtRate ||
                colvisCtv.brandRiskFloorFree ||
                colvisCtv.viewabilityRate ||
                // colvisCtv.mfaRisk ||
                colvisCtv.impressionRange
            ),
            children: [
                {
                    title: "IVT Rate",
                    dataIndex: "ivtRate",
                    key: "ivtRate",
                    width: 120,
                    hidden: !colvisCtv["ivtRate"],
                    onHeaderCell: () => ({
                        className: 'border_right_ts',
                    }),
                    render: (value) => {
                        if (value === null || value === undefined) return "-";
                        return value;
                    },
                },
                {
                    title: "Brand Risk Floor Free",
                    dataIndex: "brandRiskFloorFree",
                    key: "brandRiskFloorFree",
                    width: 170,
                    hidden: !colvisCtv["brandRiskFloorFree"],
                    onHeaderCell: () => ({
                        className: 'border_right_ts',
                    }),
                    render: (value) => {
                        if (value === null || value === undefined) return "-";
                        return value;
                    },
                },
                {
                    title: "Viewability",
                    dataIndex: "viewabilityRate",
                    key: "viewabilityRate",
                    width: 120,
                    hidden: !colvisCtv["viewabilityRate"],
                    onHeaderCell: () => ({
                        className: 'border_right_ts',
                    }),
                    render: (value) => {
                        if (value === null || value === undefined) return "-";
                        return value;
                    },
                },
                // {
                //     title: "MFA Risk",
                //     dataIndex: "mfaRisk",
                //     key: "mfaRisk",
                //     width: 120,
                //     hidden: !colvisCtv["mfaRisk"],
                //     onHeaderCell: () => ({
                //         className: 'border_right_ts',
                //     }),
                //     render: (value) => {
                //         if (value === null || value === undefined) return "-";
                //         return value;
                //     },
                // },
                {
                    title: "Impression Range",
                    dataIndex: "impressionRange",
                    key: "impressionRange",
                    width: 140,
                    hidden: !colvisCtv["impressionRange"],
                    render: (value) => {
                        if (value === null || value === undefined) return "-";
                        return value;
                    },
                },
            ]
        },

    ]


    const mergedColumnsCTV = columnsCTV.map((col) => {
        // 🚨 Skip columns without dataIndex
        if (!col.dataIndex) return col;

        const meta = inventoryTemplates.CTV[col.dataIndex];

        if (!meta || !editableFieldsByType.ctv.includes(col.dataIndex)) {
            return col;
        }

        return {
            ...col,
            onCell: (record) => ({
                record,
                dataIndex: col.dataIndex,
                inputType: meta.type,
                options:
                    col.dataIndex === "geo"
                        ? countryOptions
                        : meta.options || [],
                rules: buildRules(meta),
                editing: isEditing(record),
            }),
        };
    });


    const columnsMobile = [
        {
            title: '',
            // dataIndex: 'action',
            key: 'action',
            fixed: 'left',
            className: (checkRole === "admin" || checkRole === "u_admin") ? '' : 'ps-0',
            width: (checkRole === "admin" || checkRole === "u_admin") ? 85 : 70,
            onHeaderCell: () => ({
                className: (checkRole === "admin" || checkRole === "u_admin") ? 'border_right_0' : 'border_right_0 ps-0',
            }),
            render: (_, record) => {
                const editable = isEditing(record);
                return (
                    <>
                        <div className="">
                            {editable ? (
                                <div className="d-flex gap-2">
                                    <Typography.Link onClick={(e) => {
                                        e.stopPropagation();
                                        save(record._id);
                                    }}>
                                        <Tooltip title="Save">
                                            <div className='d-flex align-items-center' style={{ gap: '0.6rem' }}>
                                                <div className='div_of_icon --save_icon_div cursor_pointer'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <path d="M11.6663 3.5L5.24967 9.91667L2.33301 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </Tooltip>

                                    </Typography.Link>
                                    <Typography.Link onClick={(e) => {
                                        e.stopPropagation();
                                        cancel();
                                    }}>
                                        <Tooltip title="Cancel">
                                            <div className='d-flex align-items-center' style={{ gap: '0.6rem' }}>
                                                <div className='div_of_icon --cancel_icon_div cursor_pointer'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <path d="M10.5 3.5L3.5 10.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M3.5 3.5L10.5 10.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </Tooltip>

                                    </Typography.Link>
                                </div>
                            ) : (
                                <Tooltip title="Edit">
                                    <div className='download_icon download_icon_d2 text-center'
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            edit(record);
                                        }}>
                                        <img src={Edit} alt="" className='img-fluid cursor_pointer' />
                                    </div>
                                </Tooltip>
                            )}

                        </div >
                    </>
                )
            }
        },

        {
            title: 'Status',
            // dataIndex: 'action',
            key: 'status',
            fixed: 'left',
            className: (checkRole === "admin" || checkRole === "u_admin") ? '' : 'ps-0',
            width: (checkRole === "admin" || checkRole === "u_admin") ? 160 : 100,
            onHeaderCell: () => ({
                className: (checkRole === "admin" || checkRole === "u_admin") ? 'border_right_0' : 'border_right_0 ps-0',
            }),
            render: (_, record) => {
                const editable = isEditing(record);
                return (
                    <div className="d-flex gap-2">

                        {(checkRole !== "admin" && checkRole !== "u_admin") && !editable &&
                            <>

                                {record.status === "pending" ?
                                    <div className='btn_group --btn_group_select' style={{ width: '80%' }}>
                                        <div onClick={() => statusChange("approved", [record._id], "")}>
                                            <Tooltip title='Approve'>
                                                <button className='btn_outline_success btn --diff_clr_of_approved_box'>
                                                    <img src={checkIcon} alt='USP' />
                                                </button>
                                            </Tooltip>
                                        </div>

                                        <div >
                                            <Tooltip title='Reject'>

                                                <Select
                                                    value="Reject"
                                                    suffixIcon={null}   // 👈 default arrow remove
                                                    labelRender={(label) => (
                                                        <span className="reject_label">
                                                            <img src={crossIcon} alt="Reject" />
                                                        </span>
                                                    )}
                                                    dropdownMatchSelectWidth={false}
                                                    // style={{ width: 140 }}
                                                    className="reject_select"
                                                    onChange={(event) => { statusChange("rejected", [record._id], event) }}
                                                    dropdownRender={(menu) => (
                                                        <>
                                                            <div className="select_dropdown_header">
                                                                Please specify the reason of rejection
                                                            </div>
                                                            {menu}
                                                        </>
                                                    )}
                                                    options={rejectionOptionsApp}
                                                />
                                            </Tooltip>
                                        </div>
                                    </div>
                                    :
                                    <div className={record.status === "approved" ? "case_select_tag" : "case_select_tag --rejected_cascader"}>
                                        <Cascader
                                            options={rejectionOptionsCascaderApp}
                                            placeholder=""
                                            // open={true}
                                            // dropdownAlign={{
                                            //     points: ['tl', 'bl'],
                                            //     overflow: {
                                            //         adjustX: false,
                                            //         adjustY: false, // ❌ auto upar le jana band
                                            //     },
                                            // }}
                                            allowClear={false}
                                            value={
                                                record.status === "approved"
                                                    ? ["Approved"]
                                                    : record.status === "rejected" && record.rejectionReason
                                                        ? ["Rejected", record.rejectionReason]
                                                        : ["Rejected"]
                                            }
                                            // defaultValue='Approved'
                                            // open={true}
                                            popupClassName="reject_reason_popover"
                                            onChange={(value) => handleStatusChange(value, record)}
                                            style={{ width: 'auto' }}
                                            displayRender={(labels) => labels[0]} // ✅ sirf parent show
                                            suffixIcon={null}
                                            expandIcon={
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M6.0016 12.655C5.82827 12.655 5.66159 12.5883 5.52825 12.4617C5.26825 12.2017 5.26825 11.7817 5.52825 11.5217L9.05494 7.99502L5.52825 4.46835C5.26825 4.20835 5.26825 3.78834 5.52825 3.52834C5.78825 3.26834 6.20827 3.26834 6.46827 3.52834L10.4683 7.52834C10.7283 7.78834 10.7283 8.20835 10.4683 8.46835L6.46827 12.4683C6.33494 12.6017 6.16826 12.6617 5.99493 12.6617L6.0016 12.655Z" fill="#98A2B3" />
                                                </svg>
                                            }
                                        />
                                    </div>
                                }
                            </>
                        }
                        {(checkRole === "admin" || checkRole === "u_admin") && !editable &&
                            <div>
                                <Select
                                    className={`form_select badge_content--${record.status?.toLowerCase() === "pending" ? "new" : record.status?.toLowerCase()}`}
                                    dropdownStyle={{
                                        width: '14rem'
                                    }}
                                    style={{ pointerEvents: "none" }}
                                    value={record?.status}
                                    options={
                                        [{ label: "Approved", value: "approved" }, { label: "Rejected", value: "rejected" }, { label: "Pending", value: "pending" }]

                                    }
                                />
                            </div>
                        }
                    </div >
                )
            }
        },
        {
            title: "App Name",
            dataIndex: "app_name",
            key: "app_name",
            width: 180,
            fixed: 'left',
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            // fixed: 'left',
            onHeaderCell: () => ({
                className: "border_right_0",
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{value}</>

                );
            }
        },

        {
            title: 'ads.txt',
            dataIndex: 'adstxtChecking',
            key: 'adstxtChecking',
            sorter: false,
            fixed: 'left',
            width: 80,
            onHeaderCell: () => ({
                className: 'text-end',
            }),
            render: (_, record) => {
                return (
                    <div className='d-flex align-items-center justify-content-end w-100'>
                        <div className='sheetbadgearea'
                            onClick={() => {
                                if (record.adstxtChecking !== undefined && record.adstxtChecking !== null && record.adstxtChecking !== "" && record.adstxtChecking === false) {
                                    setIsModalVisibleAdstxt(true)
                                    setModalVisibleAdstxtData(record.adstxtData)
                                }
                            }}
                        >

                            {/* for number */}

                            {
                                !(record.adstxtChecking === undefined || record.adstxtChecking === null || record.adstxtChecking === "" || record.adstxtChecking === false) ?
                                    <>
                                        <Tooltip title="We are checking ads.txt file. Please check back later.">
                                            {/* for tooltip */}
                                            <div className='sheetbadgediv --yellow_badge'>

                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                    <path d="M5 5L2.625 3.21875C2.58641 3.18943 2.55507 3.15165 2.5334 3.1083C2.51173 3.06496 2.5003 3.01721 2.5 2.96875V1.5625C2.5 1.47962 2.53292 1.40013 2.59153 1.34153C2.65013 1.28292 2.72962 1.25 2.8125 1.25H7.1875C7.27038 1.25 7.34987 1.28292 7.40847 1.34153C7.46708 1.40013 7.5 1.47962 7.5 1.5625V2.95312C7.4997 3.00159 7.48828 3.04933 7.4666 3.09268C7.44493 3.13602 7.41359 3.17381 7.375 3.20312L5 5Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M5 5L2.625 6.78125C2.58641 6.81057 2.55507 6.84835 2.5334 6.8917C2.51173 6.93504 2.5003 6.98279 2.5 7.03125V8.4375C2.5 8.52038 2.53292 8.59987 2.59153 8.65847C2.65013 8.71708 2.72962 8.75 2.8125 8.75H7.1875C7.27038 8.75 7.34987 8.71708 7.40847 8.65847C7.46708 8.59987 7.5 8.52038 7.5 8.4375V7.04687C7.4997 6.99841 7.48828 6.95067 7.4666 6.90732C7.44493 6.86398 7.41359 6.82619 7.375 6.79688L5 5Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>

                                            </div>
                                        </Tooltip>
                                    </>
                                    :
                                    <>
                                        <div className={record.adstxtLineCount !== 0 ? 'sheetbadgediv ' : 'sheetbadgediv --red_badge'}

                                        >
                                            <span>{record.adstxtLineCount}</span>
                                        </div>

                                    </>


                            }

                            <img src={SheetIcon} alt='' />
                        </div >
                    </div>
                )
            }
        },

        {
            title: "Publisher",
            dataIndex: "p_name",
            key: "p_name",
            hidden: (checkRole === "admin" || checkRole === "u_admin"),
            width: 180,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value, record) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{record.adk_id}-{value}</>

                );
            }
        },

        {
            title: "Inventory Provider",
            dataIndex: "inventory_provider",
            key: "inventory_provider",
            width: 180,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{value}</>

                );
            }
        },
        {
            title: "App Bundle",
            dataIndex: "app_bundle",
            key: "app_bundle",
            width: 180,
            sorter: true,
            hidden: !colvisMobile["app_bundle"],
            sortDirections: ['ascend', 'descend', 'ascend'],
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{value}</>

                );
            }
        },
        {
            title: "App Store URL",
            dataIndex: "app_store_url",
            key: "app_store_url",
            hidden: !colvisMobile["app_store_url"],
            width: 180,
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";
                if (value === "NA") return "NA";

                const text = String(value);
                const isLong = text.length > 30;
                const href = text.includes("https://") ? text : `https://${text}`;

                const link = (
                    <a
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                        className="text_primary"
                    >
                        {isLong ? `${text.slice(0, 30)}...` : text}
                    </a>
                );

                return isLong ? (
                    <Tooltip title={text} placement="top">
                        {link}
                    </Tooltip>
                ) : (
                    link
                );
            }
        },
        {
            title: "App-ads.txt URL",
            dataIndex: "app_ads_txt_url",
            key: "app_ads_txt_url",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 180,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";
                if (value === "NA") return "NA";

                const text = String(value);
                const isLong = text.length > 30;
                const href = text.includes("https://") ? text : `https://${text}`;

                const link = (
                    <a
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                        className="text_primary"
                    >
                        {isLong ? `${text.slice(0, 30)}...` : text}
                    </a>
                );

                return isLong ? (
                    <Tooltip title={text} placement="top">
                        {link}
                    </Tooltip>
                ) : (
                    link
                );
            }
        },

        {
            title: "Traffic Type",
            dataIndex: "traffic_type",
            key: "traffic_type",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 140,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <div style={{ textTransform: "lowercase" }}>{value}</div>

                );
            }
        },
        {
            title: "Geo",
            dataIndex: "geo",
            key: "geo",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 200,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                const country = countryOptions.find(c => c.value === value);
                return country ? country.label : value;
            }
        },
        {
            title: "Avg eCPM ($)",
            dataIndex: "avg_ecpm",
            key: "avg_ecpm",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 100,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{value}</>

                );
            }
        },
        {
            title: "Last 30 Avails",
            dataIndex: "last_30_avails",
            key: "last_30_avails",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 130,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                return (
                    <>{formatNumber(value)}</>

                );
            }
        },
        {
            title: "Rejection Reason",
            dataIndex: "rejectionReason",
            key: "rejectionReason",
            hidden: !colvisMobile["rejectionReason"],
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            width: 120,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined || value === "") return "-";

                if (value === "NA") return "NA";

                return (
                    <>{value}</>

                );
            }
        },
        {
            title: "Supply Lens",
            key: "supplyLensMobile",
            onHeaderCell: () => ({
                className: 'diff_border_line_clr',
            }),
            hidden: !(
                colvisMobile.ivtRate ||
                colvisMobile.brandRiskFloorFree ||
                colvisMobile.viewabilityRate ||
                // colvisMobile.mfaRisk ||
                colvisMobile.impressionRange
            ),
            children: [
                {
                    title: "IVT Rate",
                    dataIndex: "ivtRate",
                    key: "ivtRate",
                    width: 120,
                    hidden: !colvisMobile["ivtRate"],
                    onHeaderCell: () => ({
                        className: 'border_right_ts',
                    }),
                    render: (value) => {
                        if (value === null || value === undefined) return "-";
                        return value;
                    },
                },
                {
                    title: "Brand Risk Floor Free",
                    dataIndex: "brandRiskFloorFree",
                    key: "brandRiskFloorFree",
                    width: 170,
                    hidden: !colvisMobile["brandRiskFloorFree"],
                    onHeaderCell: () => ({
                        className: 'border_right_ts',
                    }),
                    render: (value) => {
                        if (value === null || value === undefined) return "-";
                        return value;
                    },
                },
                {
                    title: "Viewability",
                    dataIndex: "viewabilityRate",
                    key: "viewabilityRate",
                    width: 120,
                    hidden: !colvisMobile["viewabilityRate"],
                    onHeaderCell: () => ({
                        className: 'border_right_ts',
                    }),
                    render: (value) => {
                        if (value === null || value === undefined) return "-";
                        return value;
                    },
                },
                // {
                //     title: "MFA Risk",
                //     dataIndex: "mfaRisk",
                //     key: "mfaRisk",
                //     width: 120,
                //     hidden: !colvisMobile["mfaRisk"],
                //     onHeaderCell: () => ({
                //         className: 'border_right_ts',
                //     }),
                //     render: (value) => {
                //         if (value === null || value === undefined) return "-";
                //         return value;
                //     },
                // },
                {
                    title: "Impression Range",
                    dataIndex: "impressionRange",
                    key: "impressionRange",
                    width: 140,
                    hidden: !colvisMobile["impressionRange"],
                    render: (value) => {
                        if (value === null || value === undefined) return "-";
                        return value;
                    },
                },
            ]
        },

    ]

    const mergedColumnsMobile = columnsMobile.map((col) => {
        // 🚨 Skip columns without dataIndex
        if (!col.dataIndex) return col;

        const meta = inventoryTemplates["Mobile App"][col.dataIndex];

        if (!meta || !editableFieldsByType.mobile.includes(col.dataIndex)) {
            return col;
        }

        return {
            ...col,
            onCell: (record) => ({
                record,
                dataIndex: col.dataIndex,
                inputType: meta.type,
                options:
                    col.dataIndex === "geo"
                        ? countryOptions
                        : meta.options || [],
                rules: buildRules(meta),
                editing: isEditing(record),
            }),
        };
    });

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)
    const [tabLoad, setTabLoad] = useState(false)

    useEffect(() => {
        setEditingKey("");
        form.resetFields();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    // useEffect(() => {
    //     setSelectedRowKeys([]);
    //     setSelectedRowIds([]);
    // }, [filter]);

    const [page, setPage] = useState({
        current: 1,
        pageSize: 20,
        total: 10,
    });

    const [sort, setSort] = useState({
        name: "createdAt",
        type: "descend"
    });

    const [search, setSearch] = useState("")



    // const colvisLabelMap = useMemo(() => {
    //     if (filter === "web") return buildColvisLabelMap(columnsWebsite);
    //     if (filter === "mobile") return buildColvisLabelMap(columnsMobile);
    //     if (filter === "ctv") return buildColvisLabelMap(columnsCTV);
    //     return {};
    // }, [filter]);

    // const toggleCol = (key) => {
    //     setColvisByType(prev => ({
    //         ...prev,
    //         [filter]: {
    //             ...prev[filter],
    //             [key]: !prev[filter][key],
    //         },
    //     }));
    // };

    // const colvisKeys = COLVIS_KEYS_BY_TYPE[filter] || [];

    // const checkedCount = colvisKeys.filter(k => activeColvis[k]).length;

    // const isAllChecked = checkedCount === colvisKeys.length;
    // const isIndeterminate = checkedCount > 0 && !isAllChecked;

    // const toggleSelectAll = (checked) => {
    //     const updated = {};
    //     colvisKeys.forEach(k => {
    //         updated[k] = checked;
    //     });

    //     setColvisByType(prev => ({
    //         ...prev,
    //         [filter]: updated,
    //     }));
    // };


    // useEffect(() => {
    //     setColvisByType(prev => {
    //         if (Object.keys(prev[filter] || {}).length) return prev;

    //         const defaults = {};
    //         COLVIS_KEYS_BY_TYPE[filter].forEach(k => {
    //             defaults[k] = true; // default visible
    //         });

    //         return {
    //             ...prev,
    //             [filter]: defaults,
    //         };
    //     });
    // }, [filter]);




    const getData = () => {
        const token = isRegisterFlow ? null : Cookies.get("token_xapads_ssp");
        if (!isRegisterFlow && !token) return;

        const queryParam = isRegisterFlow ? `?_id=${registerPubId}` : "";
        axios
            .post(configData.SERVER_URL + `ops/inventoryList${queryParam}`, {
                "inventoryType": filter,
                "page": page.current,
                "limit": page.pageSize,
                "sortBy": sort.name,
                "sortOrder": sort.type === "descend" ? "desc" : "asc",
                "search": search,
                "publisher": filterApplyApiCall.publisher,
                "status": filterApplyApiCall.status,
                "pixalateRisk": filter === "web" ? filterApplyApiCall.riskType : [],
                "inventory_provider": filterApplyApiCall.inventoryProvider,
                "traffic_type": filter !== "ctv" ? filterApplyApiCall.trafficType : [],
                "primary_iab": filter === "web" ? filterApplyApiCall.iab : [],
                "brandRiskFloorFree": filterApplyApiCall.brandRiskFloorFree,
                "mfaRisk": filter === "web" ? filterApplyApiCall.mfaRisk : [],
            }, {
                headers: {
                    "Content-Type": "application/json",
                    ...(token ? { "x-access-token": token } : {}),
                },
            })
            .then((response) => {
                setData(response?.data?.data)
                if (response.data.data.length > 0) {
                    let tempPage = { ...page }
                    tempPage.total = response.data.pagination.total

                    setPage(tempPage)

                    let tempCountRecords = { ...countRecords }

                    tempCountRecords.approved = response.data.statusCounts.approved
                    tempCountRecords.rejected = response.data.statusCounts.rejected
                    tempCountRecords.pending = response.data.statusCounts.pending

                    setCountRecords(tempCountRecords)

                    // console.log('Data:', data.map(d => d._id));


                }
                else {
                    let tempCountRecords = { ...countRecords }

                    tempCountRecords.approved = 0
                    tempCountRecords.rejected = 0
                    tempCountRecords.pending = 0

                    setCountRecords(tempCountRecords)
                }

                setPlatformTotal((response.data.platformTotals === undefined || response.data.platformTotals === null) ? { "web": 0, "mobile": 0, "ctv": 0 } : response.data.platformTotals)

                // setColumnPartialData(response.data.partial)
                // setColumnTimeData(response.data.pix_updatedAt)

                setLoading(false)
                setTabLoad(false)
                setInitialLoad(false)
            })
            .catch((error) => {
                setData([])

                setLoading(false)
                setTabLoad(false)
                setInitialLoad(false)

                setPlatformTotal({ "web": 0, "mobile": 0, "ctv": 0 })
            });

    }

    // Function to convert JSON to CSV
    // const convertToCSV = (data, headers) => {
    //     const csvRows = [];
    //     const headerRow = headers.map(header => header.label).join(",");
    //     csvRows.push(headerRow);
    //     data.forEach(row => {
    //         const rowData = headers.map(header => {
    //             let value = row[header.key] ?? "";
    //             if (header.key === "IM") {
    //                 if (Object.keys(value).length > 0) {
    //                     value = `${value.label} (${value.value})`
    //                 }
    //             }
    //             if (header.key === "givtImpressions") {
    //                 const givtImpsRate = row["givtImpsRate"] ?? 0;
    //                 if (value !== "0") { value = `${value} (${givtImpsRate}%)`; }
    //             }
    //             if (header.key === "sivtImpressions") {
    //                 const sivtImpsRate = row["sivtImpsRate"] ?? 0;
    //                 if (value !== "0") { value = `${value} (${sivtImpsRate}%)`; }
    //             }
    //             if (header.key === "givtSivtImp") {
    //                 const givtSivtRate = row["givtSivtRate"] ?? 0;
    //                 if (value !== "0") { value = `${value} (${givtSivtRate}%)`; }
    //             }
    //             if (header.key === "viewability") {
    //                 if (value !== undefined) { value = `${value}% `; }
    //             }
    //             if (header.key === "AM") {
    //                 if (value !== undefined) {
    //                     value = value.length > 0 ? value.join(",") : "";
    //                 }
    //             }
    //             if (header.key === "Country") { value = row["countryName"]; }
    //             return `"${String(value).replace(/"/g, '""')}"`;
    //         });
    //         csvRows.push(rowData.join(","));
    //     });
    //     return csvRows.join("\n");
    // };

    const getDataExport = () => {
        setExportLoading(true)

        const token = isRegisterFlow ? null : Cookies.get("token_xapads_ssp");
        if (!isRegisterFlow && !token) { setExportLoading(false); return; }

        const queryParam = isRegisterFlow ? `?_id=${registerPubId}` : "";
        axios
            .post(configData.SERVER_URL + `ops/inventoryList${queryParam}`, {
                "inventoryType": filter,
                "page": page.current,
                "limit": page.pageSize,
                "sortBy": sort.name,
                "sortOrder": sort.type === "descend" ? "desc" : "asc",
                "search": search,
                "publisher": filterApplyApiCall.publisher,
                "status": filterApplyApiCall.status,
                "pixalateRisk": filter === "web" ? filterApplyApiCall.riskType : [],
                "inventory_provider": filterApplyApiCall.inventoryProvider,
                "traffic_type": filter !== "ctv" ? filterApplyApiCall.trafficType : [],
                "primary_iab": filter === "web" ? filterApplyApiCall.iab : [],
                "brandRiskFloorFree": filterApplyApiCall.brandRiskFloorFree,
                "mfaRisk": filter === "web" ? filterApplyApiCall.mfaRisk : [],
                "export": true
            }, {
                headers: {
                    "Content-Type": "application/json",
                    ...(token ? { "x-access-token": token } : {}),
                },
                responseType: "blob",
            })
            .then((response) => {
                if (response.data) {
                    const blob = new Blob([response.data], {
                        // type: "text/plain;charset=utf-8",
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    saveAs(blob, "Inventory_" + filter + "_" + new Date().getTime() + ".xlsx");
                }

                setExportLoading(false)

            })
            .catch((error) => {
                if (error?.response) {
                    if (error?.response?.data?.message?.length !== 0) {
                        notifyfailure(error.response.data.message)
                    }
                } else {
                    notifycatch()
                }
                setExportLoading(false)
            });
    }

    useEffect(() => {
        if (!isRegisterFlow) {
            TokenVerificationLoggedin();
            let token = Cookies.get("token_xapads_ssp");
            if (token) {
                setCheckRole(jwtDecode(token).role);
            }
        }
        // register flow keeps checkRole = "admin" (default) → shows admin view

        axios
            .get(configData.SERVER_URL + "ops/inventoryCountryList")
            .then(res => { setCountryOptions(res.data.data); })
            .catch(() => { });

        loadingContext.done()
    }, [loadingContext]);



    useEffect(() => {
        // if (!initialLoad) {
        getData()
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiCall])

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                // Only set loading if there's actual search text
                if (search.trim().length > 0) {
                    setLoading(true)
                }
                let tempPage = page
                tempPage.current = 1
                setPage(tempPage);
                setSelectedRowKeys([])
                setSelectedRowIds([])
                setApicall(!apiCall)
            }, 400); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);


    function handleTabChange(event) {
        let data = event.target.value
        if (filter !== event.target.value) {
            setTabLoad(true)
        }
        setFilter(data)
        let tempPage = page
        tempPage.current = 1
        tempPage.total = 10
        setPage(tempPage)

        let tempCountRecords = { ...countRecords }
        tempCountRecords.approved = 0
        tempCountRecords.rejected = 0
        tempCountRecords.pending = 0
        setCountRecords(tempCountRecords)

        setSelectedRowKeys([])
        setSelectedRowIds([])

        // setPage({
        //   current: 1,
        //   pageSize: 10,
        //   total: 10,
        // })
        if (search !== "") setSearch("")
        setSort({
            name: "createdAt",
            type: "descend"
        })
        resetSorter()
        // setApicall(!apiCall) // REMOVED: This causes double API call. The useEffect watching filterApplyApiCall will trigger the API call when filter changes
        // if(data==="Website"){
        //   setTableColumns(columnsWebsite)
        // }
        // else if(data==="Mobile"){
        //   setTableColumns(columnsCTV)
        // }
        // else if(data==="CTV"){
        //   setTableColumns(columnsOnboard)
        // }
    }

    const resetSorter = () => {
        setTimeout(() => {
            document.querySelectorAll('th[aria-sort]').forEach(th => {
                th.removeAttribute('aria-sort');
            });

            document.querySelectorAll('span[aria-label="caret-up"]').forEach(span => {
                span.classList.remove('active');
            });

            document.querySelectorAll('span[aria-label="caret-down"]').forEach(span => {
                span.classList.remove('active');
            });

        }, 0);

    };


    const handleTableChange = (pagination, filters, sorter) => {
        // const pager = { ...page };
        // pager.current = pagination.current;
        // setPage(pager);
        // let order;
        // if (sort.name === sorter.field) {
        //   order = sort.type === 'ascend' ? 'descend' : 'ascend';
        // } else {
        //   order = 'ascend';
        // }
        setSelectedRowKeys([])
        setSelectedRowIds([])
        setSort({ name: sorter.field, type: sorter.order });
        // fetchData({
        //   sortField: sorter.field,
        //   sortOrder: sorter.order,
        //   pagination: pager,
        //   ...filters,
        // });
        setApicall(!apiCall)
        setLoading(true)
    };

    // const fetchAndDownloadFiles = async (urls) => {
    //     let name = 1
    //     try {
    //         const zip = new JSZip();
    //         const promises = urls.map(async (ob, index) => {
    //             try {
    //                 const response = await fetch("https://unified-supply-platform.s3.ap-south-1.amazonaws.com/mediaKit/1720698869515-file_example_PPT_1MB.ppt")
    //                 if (!response.ok) {
    //                     throw new Error(`Failed to fetch ${ob?.url}: ${response.statusText}`);
    //                 }
    //                 const blob = await response.blob();
    //                 zip.file(ob.fileName + "." + ob?.ext, blob);
    //             } catch (error) {
    //                 console.error("Error fetching file:", error);
    //             }
    //         });
    //         await Promise.all(promises);
    //         const zipBlob = await zip.generateAsync({ type: "blob" });
    //         FileSaver.saveAs(zipBlob, "attachments.zip");
    //         notifysuccess("Media kit downloaded successfully");
    //     } catch (error) {
    //         notifyfailure("Error while fetching the media kit.");
    //     }
    // };

    const [rejectionOptions] = useState([
        { value: "Domain has a low viewability score", label: "Domain has a low viewability score" },
        { value: "Domain has a low trust score", label: "Domain has a low trust score" },
        { value: "Domain has a high SIVT percentage", label: "Domain has a high SIVT percentage" },
        { value: "Domain has a high IVT percentage", label: "Domain has a high IVT percentage" },
        { value: "No Data available on Pixalate for review", label: "No Data available on Pixalate for review" },
        { value: "Domain has Brand Safety Issues", label: "Domain has Brand Safety Issues" },
        { value: "Invalid ads.txt page", label: "Invalid ads.txt page" },
        { value: "Domain is not Owned & Operated", label: "Domain is not Owned & Operated" },
    ])

    const [rejectionOptionsApp] = useState([
        { value: "App Not Owned & Operated", label: "App Not Owned & Operated" },
        { value: "Invalid or Non - existent App Store URL", label: "Invalid or Non - existent App Store URL" },
        { value: "Insufficient App Installs / Low Scale", label: "Insufficient App Installs / Low Scale" },
        { value: "High Invalid Traffic(IVT)", label: "High Invalid Traffic(IVT)" },
    ])


    const [rejectionOptionsCtv] = useState([
        { value: "App Not Owned & Operated", label: "App Not Owned & Operated" },
        { value: "Missing or Invalid App - ads.txt page", label: "Missing or Invalid App - ads.txt page" },
        { value: "Invalid or Non - existent App Store URL", label: "Invalid or Non - existent App Store URL" },
        { value: "Inventory Partner Domain is not there", label: "Inventory Partner Domain is not there" },
        { value: "No Data available on Pixalate for High Invalid Traffic(IVT)", label: "No Data available on Pixalate for review" },
    ])

    const [rejectionOptionsCascader] = useState([
        {
            value: 'approved',
            label: 'Approved',
        },
        {
            value: 'rejected',
            label: 'Rejected',
            children: [
                { value: "Domain has a low viewability score", label: "Domain has a low viewability score" },
                { value: "Domain has a low trust score", label: "Domain has a low trust score" },
                { value: "Domain has a high SIVT percentage", label: "Domain has a high SIVT percentage" },
                { value: "Domain has a high IVT percentage", label: "Domain has a high IVT percentage" },
                { value: "No Data available on Pixalate for review", label: "No Data available on Pixalate for review" },
                { value: "Domain has Brand Safety Issues", label: "Domain has Brand Safety Issues" },
                { value: "Invalid ads.txt page", label: "Invalid ads.txt page" },
                { value: "Domain is not Owned & Operated", label: "Domain is not Owned & Operated" },
            ]
        }
    ])




    const [rejectionOptionsCascaderApp] = useState([
        {
            value: 'approved',
            label: 'Approved',
        },
        {
            value: 'rejected',
            label: 'Rejected',
            children: [
                { value: "App Not Owned & Operated", label: "App Not Owned & Operated" },
                { value: "Invalid or Non - existent App Store URL", label: "Invalid or Non - existent App Store URL" },
                { value: "Insufficient App Installs / Low Scale", label: "Insufficient App Installs / Low Scale" },
                { value: "High Invalid Traffic(IVT)", label: "High Invalid Traffic(IVT)" },
            ]
        }
    ]
    )

    const [rejectionOptionsCascaderCtv] = useState([
        {
            value: 'approved',
            label: 'Approved',
        },
        {
            value: 'rejected',
            label: 'Rejected',
            children: [
                { value: "App Not Owned & Operated", label: "App Not Owned & Operated" },
                { value: "Missing or Invalid App - ads.txt page", label: "Missing or Invalid App - ads.txt page" },
                { value: "Invalid or Non - existent App Store URL", label: "Invalid or Non - existent App Store URL" },
                { value: "Inventory Partner Domain is not there", label: "Inventory Partner Domain is not there" },
                { value: "No Data available on Pixalate for High Invalid Traffic(IVT)", label: "No Data available on Pixalate for review" },
            ]
        }
    ]
    )


    function statusChange(statusFlag, id, reason) {

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");

            let payload = {
                "inventoryType": filter,
                "status": statusFlag,
                "inventoryIds": id,
                "rejectionReason": reason
            }

            setLoading(true)
            axios
                .post(configData.SERVER_URL + `ops/inventoryStatus`, payload, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setApicall(!apiCall)
                    setSelectedRowKeys([])
                    setSelectedRowIds([])
                    notifysuccess(response.data.message);

                })
                .catch((error) => {
                    if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message)
                    }
                    else {
                        notifycatch()
                    }
                    setLoading(false)

                });

        }
    }

    const handleStatusChange = (value, record) => {
        const statusFlag = value[0].toLowerCase(); // approved | rejected
        const rejectionReason = value.length > 1 ? value[1] : null;


        statusChange(
            statusFlag,
            [record._id],
            rejectionReason
        );
    };

    const handlePageChange = (data) => {
        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setSelectedRowKeys([])
        setSelectedRowIds([])
        setApicall(!apiCall)
        setLoading(true)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = 1
            }
        }
        setSelectedRowKeys([])
        setSelectedRowIds([])
        setPage(tempPage);
        setApicall(!apiCall)
        setLoading(true)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };


    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>
                        {/* <img src={errorData} className='' alt="" /> */}
                        <div className='float_text_div'>
                            {/* <h1 className='no_data_heading'>Sorry! No result found :(</h1>
               <p className='no_data_para'>Please check the spelling or try searching for something else. </p> */}
                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>
                                {/* <h1 className='no_data_heading'>Sorry! No result found :(</h1>
                <p className='no_data_para'>Please check the spelling or try searching for something else. </p> */}
                            </div>
                        </div>
                    </div>
                    :

                    loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>
                                {/* <img src={errorData} className='' alt="" /> */}
                                <div className='float_text_div'>
                                    {/* <h1 className='no_data_heading'>Sorry! No result found :(</h1>
                  <p className='no_data_para'>Please check the spelling or try searching for something else. </p> */}
                                </div>
                            </div>
                        </div>
                        :
                        <div className='no_data_screen' >
                            <div className='text-center'>
                                <img src={noData} className='' alt="" />
                                <div className='float_text_div'>
                                    {/* <h1 className='no_data_heading'>Whoops! Looks like there’s no data.</h1>
                  <p className='no_data_para'>There are no records to show you right <br /> now.</p> */}
                                </div>
                            </div>
                        </div>
            }
            </>

    };

    // const components = {
    //     header: {
    //         wrapper: (props) => (
    //             <thead {...props}>
    //                 {/* <tr>
    //                 <th colSpan={columnsWebsite.length} style={{ textAlign: 'center', background: '#fafafa' }}>
    //                     Custom Header
    //                 </th>
    //             </tr> */}
    //                 {props.children}
    //             </thead>
    //         ),
    //     },

    //     body: {
    //         wrapper: (props) => (
    //             <tbody {...props}>
    //                 {loading ? (
    //                     <>
    //                         <div className='loader_top_space'>
    //                             <div className="inside_table_two_loader">
    //                                 <img src={FullLoader} className="" alt="" />
    //                             </div>
    //                         </div>


    //                     </>
    //                 ) : (
    //                     props.children
    //                 )}
    //             </tbody>
    //         ),
    //     },
    // };


    //-----------------------------filter related code -----------------------------------------------------------------------


    const [filterShow, setFilterShow] = useState(false)
    const [filterPublishers, setFilterPublisher] = useState([])
    const [filterIab, setFilterIab] = useState([])


    const [searchValue, setSearchValue] = useState('');
    const [searchValue2, setSearchValue2] = useState('');

    const handleSearch = (e) => {
        setSearchValue(e.target.value.toLowerCase());
    };

    const handleSearch2 = (e) => {
        setSearchValue2(e.target.value.toLowerCase());
    };

    const filteredOptions = filterPublishers.filter(option =>
        option.label.toLowerCase().includes(searchValue)
    );

    const filteredOptions2 = filterIab.filter(option =>
        option.label.toLowerCase().includes(searchValue2)
    );


    useEffect(() => {
        if (isRegisterFlow) return; // register flow is admin-view, no publisher list or IAB filter needed
        const token = Cookies.get("token_xapads_ssp");
        if (!token) return;

        const role = jwtDecode(token).role;
        if (role !== "admin" && role !== "u_admin") {
            axios
                .get(configData.SERVER_URL + "ops/pubNewList", {
                    headers: { "Content-Type": "application/json", "x-access-token": token },
                })
                .then((response) => {
                    setFilterPublisher(response.data.data);
                    setPublisherList(response.data.data);
                })
                .catch(() => { });
        }


    }, []);

    useEffect(() => {
        axios
            .get(configData.SERVER_URL + "ops/categoriesList", {
                headers: { "Content-Type": "application/json" },
            })
            .then((response) => {
                if (response.data.success) setFilterIab(response.data.data);
            })
            .catch(() => { });
    }, [])


    // const getLabels = (values) => {
    //     return values.map(value => {
    //         const publisher = filterPublishers.find(publisher => publisher.value === value);
    //         return publisher ? publisher.label : value;
    //     }).join(", ");
    // };

    const searchInputRef1 = useRef(null);

    const handleDropdownVisibleChange1 = (open) => {
        if (open) {
            setTimeout(() => {
                searchInputRef1.current?.focus();
            }, 500);
        }
    };

    const searchInputRef2 = useRef(null);

    const handleDropdownVisibleChange2 = (open) => {
        if (open) {
            setTimeout(() => {
                searchInputRef2.current?.focus();
            }, 500);
        }
    };


    const emptyFilter = () => ({
        status: [],
        iab: [],
        inventoryProvider: [],
        trafficType: [],
        riskType: [],
        publisher: [],
        brandRiskFloorFree: [],
        mfaRisk: [],
    });

    const [filterApplyByTab, setFilterApplyByTab] = useState({
        web: emptyFilter(),
        mobile: emptyFilter(),
        ctv: emptyFilter(),
    });
    const [filterApplyApiCallByTab, setFilterApplyApiCallByTab] = useState({
        web: emptyFilter(),
        mobile: emptyFilter(),
        ctv: emptyFilter(),
    });

    // Derived aliases — stabilized with useMemo to prevent unnecessary API calls
    const filterApply = useMemo(() => filterApplyByTab[filter], [filterApplyByTab, filter]);
    const filterApplyApiCall = useMemo(() => filterApplyApiCallByTab[filter], [filterApplyApiCallByTab, filter]);

    useEffect(() => {
        if (!initialLoad) {
            let tempPage = page
            tempPage.current = 1
            setPage(tempPage);
            setApicall(!apiCall)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterApplyApiCall])

    function handleFilterApply(type, value) {
        let tempFilterApply = { ...filterApplyByTab[filter] };

        if (type === "status") {
            const index = tempFilterApply.status.indexOf(value);
            if (index === -1) {
                tempFilterApply.status.push(value);
            } else {
                tempFilterApply.status.splice(index, 1);
            }
        }
        if (type === "riskType") {
            const index = tempFilterApply.riskType.indexOf(value);
            if (index === -1) {
                tempFilterApply.riskType.push(value);
            } else {
                tempFilterApply.riskType.splice(index, 1);
            }
        }

        if (type === "inventoryProvider") {
            const index = tempFilterApply.inventoryProvider.indexOf(value);
            if (index === -1) {
                tempFilterApply.inventoryProvider.push(value);
            } else {
                tempFilterApply.inventoryProvider.splice(index, 1);
            }
        }

        if (type === "trafficType") {
            const index = tempFilterApply.trafficType.indexOf(value);
            if (index === -1) {
                tempFilterApply.trafficType.push(value);
            } else {
                tempFilterApply.trafficType.splice(index, 1);
            }
        }

        if (type === "publisher") {
            let newValue = [];
            if (tempFilterApply.publisher.includes(value)) {
                newValue = tempFilterApply.publisher.filter((item) => item !== value);
            } else {
                newValue = [...tempFilterApply.publisher, value];
            }
            tempFilterApply.publisher = newValue;
        }

        if (type === "iab") {
            let newValue = [];
            if (tempFilterApply.iab.includes(value)) {
                newValue = tempFilterApply.iab.filter((item) => item !== value);
            } else {
                newValue = [...tempFilterApply.iab, value];
            }
            tempFilterApply.iab = newValue;
        }

        if (type === "brandRiskFloorFree") {
            const index = tempFilterApply.brandRiskFloorFree.indexOf(value);
            if (index === -1) {
                tempFilterApply.brandRiskFloorFree.push(value);
            } else {
                tempFilterApply.brandRiskFloorFree.splice(index, 1);
            }
        }

        if (type === "mfaRisk") {
            const index = tempFilterApply.mfaRisk.indexOf(value);
            if (index === -1) {
                tempFilterApply.mfaRisk.push(value);
            } else {
                tempFilterApply.mfaRisk.splice(index, 1);
            }
        }

        setFilterApplyByTab(prev => ({ ...prev, [filter]: tempFilterApply }));
    }

    const dropdownRef = useRef(null);



    // Use a ref to track the current state of filterShow
    const filterShowRef = useRef(filterShow);

    useEffect(() => {
        // Update the ref whenever filterShow changes
        filterShowRef.current = filterShow;
    }, [filterShow]);

    useEffect(() => {
        // Function to handle clicks outside the dropdown
        function handleClickOutside(event) {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                filterShowRef
            ) {
                const select1 = document.getElementById("adcodeSelect");
                const select2 = document.getElementById("adcodeSelect2");

                const isSelect1Open =
                    select1?.closest(".ant-select")?.classList?.contains("ant-select-open");

                const isSelect2Open =
                    select2?.closest(".ant-select")?.classList?.contains("ant-select-open");

                // Close filter ONLY if both selects are closed
                if (!isSelect1Open && !isSelect2Open) {

                    let temp = JSON.parse(JSON.stringify(filterApplyApiCallByTab[filter]));

                    setFilterApplyByTab(prev => ({
                        ...prev,
                        [filter]: { ...temp }
                    }));

                    setFilterShow(false);
                }
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // }, [dropdownRef, filterShow, filterApplyApiCall, setFilterApply, setFilterShow]);
    });

    //----------------------------------------modal related code starts ---------------------------------------------------------

    const [activeTab, setActiveTab] = useState("tab1");

    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {

        let Tab1Data

        if (filter === "web") {
            setInventoryType("Website")
            setInventoryTypeTab1("Website")
            Tab1Data = "Website"
        }
        else if (filter === "ctv") {
            setInventoryType("CTV")
            setInventoryTypeTab1("CTV")
            Tab1Data = "CTV"
        }
        else {
            setInventoryType("Mobile App")
            setInventoryTypeTab1("Mobile App")
            Tab1Data = "Mobile App"
        }

        const template = inventoryTemplates[Tab1Data];
        const emptyRow = Object.keys(template).reduce((acc, key) => {
            acc[key] = "";
            return acc;
        }, {});

        setDataSource(prev => [
            ...prev,
            { key: Date.now(), ...emptyRow }
        ]);

        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        bulkUploadReset()
        manualUploadReset()
    };

    //--------------------------------------------------------------------------manual entry -------------------------------------------------
    const [inventoryTypeTab1, setInventoryTypeTab1] = useState("Website");
    const [dataSource, setDataSource] = useState([]);
    const [cellErrors, setCellErrors] = useState({});

    function manualUploadReset() {
        setInventoryTypeTab1("Website")
        setDataSource([])
        setCellErrors({})
        setSelectedPublisher("")
        setPublisherIsRequiredError(false)
        setButtonProcessing(false)
    }

    const dynamicColumns = useMemo(() => {
        const template = inventoryTemplates[inventoryTypeTab1];
        return Object.entries(template).map(([key, meta]) => ({
            title: (
                <>
                    {meta.header}
                    {meta.required && <span className="text-danger">*</span>}
                </>
            ),
            dataIndex: key,
            key,
            width: meta.header.includes("Inventory Provider") ? 480 : meta.header.includes("Store (Android/IOS/LG/etc)") ? 280 : meta.header.includes("Traffic") ? 250 : meta.header.includes("Domain") ? 200 : meta.header.includes("Geo") ? 250 : 150,
            // render: (_, record) => {
            //     const hasError = cellErrors?.[record.key]?.[key];

            //     if (meta.type === "select") {
            //         return (
            //             <Select
            //                 value={record[key]}
            //                 status={hasError ? "error" : undefined}
            //                 onChange={(val) => updateCell(record.key, key, val)}
            //                 style={{ width: "100%" }}
            //             >
            //                 {meta.options.map(opt => (
            //                     <Option key={opt} value={opt}>{opt}</Option>
            //                 ))}
            //             </Select>
            //         );
            //     }

            //     return (
            //         <Input
            //             value={record[key]}
            //             status={hasError ? "error" : undefined}
            //             onChange={(e) => updateCell(record.key, key, e.target.value)}
            //         />
            //     );
            // }
            render: (_, record) => {
                const errorMsg = cellErrors?.[record.key]?.[key];

                // if (meta.type === "select") {

                //     if (meta.header === "Geo") {
                //         return (<Select
                //             key={countryOptions.length}
                //             className="modal_select_tag_cls"
                //             showSearch
                //             placeholder="Select country"
                //             options={countryOptions}
                //             optionFilterProp="label"
                //             getPopupContainer={(triggerNode) => triggerNode?.parentNode || document.body}
                //             dropdownStyle={{
                //                 position: "fixed"
                //                 // , top: "20%"
                //             }}
                //             optionLabelProp="children"
                //             placement="bottom"
                //             style={{ width: "100%" }}

                //         />
                //         )

                //     }
                //     else {

                //         return (
                //             <div className="cell-with-error">
                //                 <Select
                //                     className="modal_select_tag_cls"
                //                     value={record[key]}
                //                     suffixIcon={
                //                         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                //                             <path d="M4 6L8 10L12 6" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                //                         </svg>
                //                     }
                //                     status={errorMsg ? "error" : undefined}
                //                     onChange={(val) => updateCell(record.key, key, val)}
                //                     style={{ width: "100%" }}
                //                 >
                //                     {meta.options.map(opt => (
                //                         <Option key={opt} value={opt}>{opt}</Option>
                //                     ))}
                //                 </Select>

                //                 <span className="error_content">
                //                     {errorMsg && (
                //                         <>
                //                             {errorMsg}
                //                         </>
                //                     )}
                //                 </span>
                //             </div>
                //         );
                //     }

                // }
                if (meta.type === "select") {
                    const isGeo = key === "geo";

                    return (
                        <div className="cell-with-error">
                            <Select
                                className="modal_select_tag_cls"
                                value={record[key]}
                                status={errorMsg ? "error" : undefined}
                                style={{ width: "100%" }}
                                showSearch={isGeo}
                                optionFilterProp={isGeo ? "label" : undefined}
                                filterOption={
                                    isGeo
                                        ? (input, option) =>
                                            option?.label?.toLowerCase().includes(input.toLowerCase())
                                        : undefined
                                }
                                options={
                                    isGeo
                                        ? countryOptions              // ✅ API data [{label,value}]
                                        : undefined
                                }
                                onChange={(val) => updateCell(record.key, key, val)}
                                suffixIcon={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4 6L8 10L12 6" stroke="#98A2B3" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                }


                            >
                                {!isGeo &&
                                    meta.options.map(opt => (
                                        <Option key={opt} value={opt}>
                                            {opt}
                                        </Option>
                                    ))}
                            </Select>

                            <span className="error_content">
                                {errorMsg}
                            </span>
                        </div>
                    );
                }


                return (
                    <div className="cell-with-error">
                        <Input
                            value={record[key]}
                            status={errorMsg ? "error" : undefined}
                            onChange={(e) => updateCell(record.key, key, e.target.value)}
                        />

                        <span className="error_content">
                            {errorMsg && (
                                <>
                                    {errorMsg}
                                </>
                            )}
                        </span>
                    </div>
                );
            }
        }));
    }, [inventoryTypeTab1, cellErrors, countryOptions]); // ✅ IMPORTANT


    const removeRow = (key) => {
        setDataSource(dataSource.filter((row) => row.key !== key));
    };


    const columns = [
        {
            title: "",
            width: 50,
            className: 'table_border_right_1',
            render: (_, record) => (
                dataSource.length > 1 ? (
                    <Tooltip title="Delete">
                        <div className="download_icon download_icon_d2">
                            <img
                                src={DeleteIcon}
                                alt=""
                                className="cursor_pointer"
                                onClick={() => removeRow(record.key)}
                            />
                        </div>
                    </Tooltip>
                ) : null
            )
        },
        ...dynamicColumns
    ];

    const updateCell = (rowKey, field, value) => {
        setDataSource(prev =>
            prev.map(row =>
                row.key === rowKey ? { ...row, [field]: value } : row
            )
        );

        // 🔥 clear error for that cell
        setCellErrors(prev => {
            if (!prev[rowKey]?.[field]) return prev;

            const updated = { ...prev };
            delete updated[rowKey][field];

            if (Object.keys(updated[rowKey]).length === 0) {
                delete updated[rowKey];
            }

            return updated;
        });
    };

    const addRow = () => {
        const template = inventoryTemplates[inventoryTypeTab1];
        const emptyRow = Object.keys(template).reduce((acc, key) => {
            acc[key] = "";
            return acc;
        }, {});

        setDataSource(prev => [
            ...prev,
            { key: Date.now(), ...emptyRow }
        ]);
    };


    const validateTable = () => {
        const template = inventoryTemplates[inventoryTypeTab1];
        const errors = {};

        dataSource.forEach((row) => {
            Object.entries(template).forEach(([key, meta]) => {
                const value = row[key];

                // required
                if (meta.required && !value) {
                    errors[row.key] ??= {};
                    // errors[row.key][key] = `${meta.header} is required`;
                    errors[row.key][key] = `This field is required`;
                    return;
                }

                // number
                if (meta.type === "number" && value && isNaN(value)) {
                    errors[row.key] ??= {};
                    // errors[row.key][key] = `${meta.header} must be a number`;
                    errors[row.key][key] = `Invalid number`;
                }

                // url
                if (meta.type === "url" && value) {
                    const domainRegex = /([a-z0-9-]+\.)+[a-z]{2,}/i;
                    if (!domainRegex.test(value)) {
                        errors[row.key] ??= {};
                        // errors[row.key][key] = `${meta.header} is invalid`;
                        errors[row.key][key] = `Invalid value`;
                    }
                }
            });
        });

        return errors;
    };

    //--------------------------------------------------------------------------bulk upload -------------------------------------------------
    const [inventoryType, setInventoryType] = useState("Website");
    const [inventoryCtvData, setInventoryCtvData] = useState([]);
    const [inventoryCtvName, setInventoryCtvName] = useState("");
    const [inventoryMobileData, setInventoryMobileData] = useState([]);
    const [inventoryMobileName, setInventoryMobileName] = useState("");
    const [inventoryWebsiteData, setInventoryWebsiteData] = useState([]);
    const [inventoryWebsiteName, setInventoryWebsiteName] = useState("");

    const [fileUploadError, setFileUploadError] = useState(false);

    const [publisherList, setPublisherList] = useState([]);
    const [selectedPublisher, setSelectedPublisher] = useState(undefined);
    const [publisherIsRequiredError, setPublisherIsRequiredError] =
        useState(false);
    const [buttonProcessing, setButtonProcessing] = useState(false);


    function bulkUploadReset() {
        setInventoryType("Website")
        setInventoryCtvData([])
        setInventoryCtvName("")
        setInventoryMobileData([])
        setInventoryMobileName("")
        setInventoryWebsiteData([])
        setInventoryWebsiteName("")
        setFileUploadError(false)
        setSelectedPublisher("")
        setPublisherIsRequiredError(false)
        setButtonProcessing(false)
    }

    function onChangePublisher(event) {
        setPublisherIsRequiredError(false)
        console.log(event)
        setSelectedPublisher(event);
    }



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (activeTab === "tab1") {
            // if (Object.keys(errors).length > 0) {
            //     setCellErrors(errors);   // 👈 highlight cells
            //     return;
            // }

            // ✅ safe to submit
            // const payload = {
            //     inventoryType,
            //     data: dataSource
            // };

            // console.log("Submitting", payload);
            const errors = validateTable();


            if (
                ((checkRole === "admin" || checkRole === "u_admin") ? true : (selectedPublisher !== "" && selectedPublisher !== undefined)) &&
                dataSource.length > 0
            ) {
                if (
                    ((checkRole === "admin" || checkRole === "u_admin") ? true : publisherIsRequiredError === false) &&
                    Object.keys(errors).length === 0
                ) {
                    let payload =
                        (checkRole === "admin" || checkRole === "u_admin")
                            ? {
                                inventoryType: inventoryTypeTab1 === "Website" ? "web" : inventoryTypeTab1 === "CTV" ? "ctv" : "mobile",
                                data: dataSource
                            }
                            : {
                                publisherId: selectedPublisher?.split("-")[0],
                                inventoryType: inventoryTypeTab1 === "Website" ? "web" : inventoryTypeTab1 === "CTV" ? "ctv" : "mobile",
                                data: dataSource
                            };

                    const createToken = isRegisterFlow ? null : Cookies.get("token_xapads_ssp");
                    if (!isRegisterFlow && !createToken) return;

                    const createQueryParam = isRegisterFlow ? `?_id=${registerPubId}` : "";
                    setButtonProcessing(true);
                    axios
                        .post(configData.SERVER_URL + `ops/createInventory${createQueryParam}`, payload, {
                            headers: {
                                'Content-Type': 'application/json',
                                ...(createToken ? { "x-access-token": createToken } : {}),
                            },
                        })
                        .then((response) => {
                            notifysuccess(response.data.message);
                            setApicall(!apiCall)
                            handleCancel()
                            setMsgInventory(1)
                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                    setButtonProcessing(false)
                                }
                            } else {
                                notifycatch();
                                setButtonProcessing(false)
                            }
                        });
                }
                else
                // (
                // Object.keys(errors).length > 0
                // )
                {
                    setCellErrors(errors);
                }
            }
            else {
                if ((checkRole !== "admin" && checkRole !== "u_admin") && (selectedPublisher === "" || selectedPublisher === undefined)) {
                    setPublisherIsRequiredError(true);
                }

            }
        }

        else {


            if (
                ((checkRole === "admin" || checkRole === "u_admin") ? true : (selectedPublisher !== "" && selectedPublisher !== undefined)) &&
                (inventoryType === "Website" ? inventoryWebsiteData.length !== 0 : true) &&
                (inventoryType === "CTV" ? inventoryCtvData.length !== 0 : true) &&
                (inventoryType === "Mobile App" ? inventoryMobileData.length !== 0 : true)
            ) {


                if (
                    ((checkRole === "admin" || checkRole === "u_admin") ? true : publisherIsRequiredError === false) &&
                    fileUploadError === false
                ) {







                    let payload =
                        (checkRole === "admin" || checkRole === "u_admin")
                            ? {

                                inventoryType: inventoryType === "Website" ? "web" : inventoryType === "CTV" ? "ctv" : "mobile",
                                data: inventoryType === "Website" ? inventoryWebsiteData : inventoryType === "CTV" ? inventoryCtvData : inventoryMobileData
                            }
                            : {
                                publisherId: selectedPublisher?.split("-")[0],
                                inventoryType: inventoryType === "Website" ? "web" : inventoryType === "CTV" ? "ctv" : "mobile",
                                data: inventoryType === "Website" ? inventoryWebsiteData : inventoryType === "CTV" ? inventoryCtvData : inventoryMobileData

                            };





                    const uploadToken = isRegisterFlow ? null : Cookies.get("token_xapads_ssp");
                    if (!isRegisterFlow && !uploadToken) return;

                    const uploadQueryParam = isRegisterFlow ? `?_id=${registerPubId}` : "";
                    setButtonProcessing(true);
                    axios
                        .post(configData.SERVER_URL + `ops/createInventory${uploadQueryParam}`, payload, {
                            headers: {
                                'Content-Type': 'application/json',
                                ...(uploadToken ? { "x-access-token": uploadToken } : {}),
                            },
                        })
                        .then((response) => {
                            notifysuccess(response.data.message);
                            setApicall(!apiCall)
                            handleCancel()
                            setMsgInventory(1)
                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                    setButtonProcessing(false)
                                }
                            } else {
                                notifycatch();
                                setButtonProcessing(false)
                            }
                        });
                }

            }
            else {

                if ((checkRole !== "admin" && checkRole !== "u_admin") && (selectedPublisher === "" || selectedPublisher === undefined)) {
                    setPublisherIsRequiredError(true);
                }

                if (
                    (inventoryType === "Website" && inventoryWebsiteData.length === 0) ||
                    (inventoryType === "CTV" && inventoryCtvData.length === 0) ||
                    (inventoryType === "Mobile App" && inventoryMobileData.length === 0)
                ) {
                    setFileUploadError(true);
                }

            }
        }
    }

    const handleBeforeUpload = async (file, fileType) => {

        const accepted = ["xlsx", "xls", "csv"];
        const ext = file.name.split(".").pop().toLowerCase();
        if (!accepted.includes(ext)) {
            notifyfailure("Only Excel/CSV files are allowed");
            return Upload.LIST_IGNORE;
        }

        try {
            const rows = await parseExcelFile(file);
            if (!rows || rows.length === 0) {
                notifyfailure("The file appears to be empty or the format is not recognized.");
                return Upload.LIST_IGNORE;
            }

            const { ok, normalizedRows, errors } = validateHeadersAndRows(rows, inventoryTemplates[fileType]);
            if (!ok) {
                errors.forEach((err) => notifyfailure(err, 5));
                return Upload.LIST_IGNORE;
            }

            // Convert normalizedRows to table format with a unique key
            const prepared = normalizedRows.map((r, idx) => ({ key: Date.now().toString() + "_" + idx, ...r }));

            // console.log(prepared)

            if (fileType === "Website") {
                setInventoryWebsiteData(prepared)
                setInventoryWebsiteName(file.name)
            }
            else if (fileType === "CTV") {
                setInventoryCtvData(prepared)
                setInventoryCtvName(file.name)
            }
            else if (fileType === "Mobile App") {
                setInventoryMobileData(prepared)
                setInventoryMobileName(file.name)
            }

            setFileUploadError(false)

            // setData(prepared);
            notifysuccess("File imported and validated successfully");
        } catch (err) {
            // console.error(err);
            notifyfailure("Failed to parse file: " + (err.message || err));
        }

        // prevent antd from auto posting file
        return Upload.LIST_IGNORE;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const template = useMemo(() => inventoryTemplates?.[inventoryType] ?? {}, [inventoryType]);

    const mergedColumns = useMemo(() => {
        // If template is empty, return empty array
        return Object.entries(template).map(([key, meta]) => {
            const header = meta.header ?? key;
            return {
                title: header,
                dataIndex: key,
                key,
                editable: true,
                inputType: meta.type === "select" ? "select" : meta.type === "number" ? "number" : "text",
                options: meta.options ?? [],
                required: meta.required ?? false,
                width: header.includes("Inventory Provider") ? 480 : header.includes("Store") ? 280 : header.includes("Traffic") ? 250 : header.includes("Domain") ? 200 : header.includes("Geo") ? 100 : 150,
                render: (value) => (value === undefined || value === null ? "" : String(value)),
            };
        });
    }, [template]);


    const columnsWithActions = useMemo(() => {
        const cols = [
            ...mergedColumns.map((col) => {
                return col;
            }),

        ];
        // return cols;

        let baseColumns = [...cols];

        return baseColumns;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mergedColumns, inventoryType]); // depends on editingKey too


    //-------------------------------------------------------------------------------------------------------------



    return (
        <>

            <div className="new_table_select_row_design_cls container_box--wrapper pt_header">
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600"> Sites & Apps </h1>
                </div>

                <div className="d_flex align-items-center justify_content_between w_100 mb_10">
                    {!initialLoad &&
                        <div className='radio_btn_with_bars w-100 justify-content-between'>
                            <div className="radios_btns --radios_btns_new">
                                <Radio.Group
                                    className='radio_btn--group mb-0'
                                    value={filter}
                                    onChange={handleTabChange}>
                                    <Radio.Button value="web">Website
                                        <small className="tabs_number_div">
                                            {platformTotal.web}
                                        </small>
                                    </Radio.Button>
                                    <Radio.Button value="mobile">Mobile App
                                        <small className="tabs_number_div"> {platformTotal.mobile}</small>
                                    </Radio.Button>
                                    <Radio.Button value="ctv">CTV
                                        <small className="tabs_number_div"> {platformTotal.ctv}</small>
                                    </Radio.Button>

                                </Radio.Group>
                            </div>
                            {!tabLoad &&
                                <>
                                    {/* <div className="bars_div">
                                        <Tooltip title="Approved">
                                            <span style={{ display: "inline-flex" }}>
                                                <GaugeItem value={page.total > 0 ? (countRecords.approved * 100) / page.total : 0} color="#0E8A5D" data={countRecords.approved} />
                                            </span>
                                        </Tooltip>
                                        <Tooltip title="Rejected">
                                            <span style={{ display: "inline-flex" }}>
                                                <GaugeItem value={page.total > 0 ? (countRecords.rejected * 100) / page.total : 0} color="#B42318" data={countRecords.rejected} />
                                            </span>
                                        </Tooltip>
                                        <Tooltip title="Pending">
                                            <span style={{ display: "inline-flex" }}>
                                                <GaugeItem value={page.total > 0 ? (countRecords.pending * 100) / page.total : 0} color="#F79009" data={countRecords.pending} />
                                            </span>
                                        </Tooltip>
                                    </div> */}
                                    <div className="new_bars_line_design">
                                        <ul>
                                            <li>
                                                {formatNumberComma(countRecords.approved)}
                                                <small>Approved</small>
                                            </li>
                                            <li>
                                                {formatNumberComma(countRecords.pending)}
                                                <small>Pending</small>
                                            </li>
                                            <li>
                                                {formatNumberComma(countRecords.rejected)}
                                                <small>Rejected</small>
                                            </li>
                                        </ul>
                                    </div>
                                </>
                            }
                        </div>
                    }
                </div >

                <div className={data.length > 0 ? "table_and_filter_div --without_filter_div" : "table_and_filter_div --without_filter_div --no_data_div_height_with_tabs"}>
                    <div className="table_area_div">
                        <div className="searchbar_with_btns">
                            <div className="d-flex justify-content-end">
                                {(selectedRowIds.length > 0) ?

                                    <div style={{ opacity: ((checkRole === "admin" || checkRole === "u_admin") || editingKey !== "") ? "0" : "1" }}
                                        className='btn_group --table_filter_option --btn_group_select --reject_approve_btns'>
                                        <span>
                                            <strong>({selectedRowIds.length})</strong>
                                            selected
                                        </span>
                                        <button className='btn_outline_success btn'
                                            // disabled={editingKeyStatus === "approved" || editingKeyStatus === "rejected" || (checkRole === "admin" || checkRole === "u_admin")}
                                            onClick={() => statusChange("approved", selectedRowIds, "")}>
                                            <img src={checkIcon} alt='USP' /> Approve
                                        </button>
                                        <Select
                                            value="Reject"
                                            // disabled={editingKeyStatus === "approved" || editingKeyStatus === "rejected" || (checkRole === "admin" || checkRole === "u_admin")}
                                            suffixIcon={null}   // 👈 default arrow remove
                                            labelRender={(label) => (
                                                <span className="reject_label">
                                                    <img src={crossIcon} alt="Reject" />
                                                    Reject
                                                </span>
                                            )}
                                            dropdownMatchSelectWidth={false}
                                            // style={{ width: 140 }}
                                            className="reject_select"
                                            onChange={(event) => { statusChange("rejected", selectedRowIds, event) }}
                                            dropdownRender={(menu) => (
                                                <>
                                                    <div className="select_dropdown_header">
                                                        Please specify the reason of rejection
                                                    </div>
                                                    {menu}
                                                </>
                                            )}
                                            options={filter === "web" ? rejectionOptions : filter === "ctv" ? rejectionOptionsCtv : rejectionOptionsApp}
                                        />
                                    </div>
                                    :
                                    <>
                                        <div className="form_content_block--group d_flex mb-0">
                                            {!initialLoad &&
                                                <div className="tooltip_svg_icon_d2 position-relative --new_layout_search_input_design">
                                                    <Input
                                                        type='text'
                                                        className='form_control basic md search_input w_table_search'
                                                        placeholder="Search"
                                                        // prefix={
                                                        //     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        //         <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="#64748B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                        //         <path d="M14.0001 13.9996L11.1001 11.0996" stroke="#64748B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                        //     </svg>
                                                        // }
                                                        value={search}
                                                        onChange={(e) => {
                                                            if (e.target.value.trim().length === 0) {
                                                                setLoading(true)
                                                            }
                                                            setSearch(e.target.value)
                                                        }
                                                        }

                                                    />
                                                    <Tooltip title={filter === "web" ? "Search is limited to Domain , Geo, Risk and Owner Domain." : " Search is limited to App Bundle , App Name, Geo and Risk."}
                                                        placement="bottom"
                                                        overlayInnerStyle={{
                                                            width: "250px"
                                                        }}
                                                    >
                                                        <img src={infoIcon} alt="" />
                                                    </Tooltip>
                                                </div>
                                            }
                                        </div>

                                        {!initialLoad &&
                                            <>
                                                <div className="custom_filter_design_d2 justify-content-end --new_layout_design_btn">
                                                    <button className='btn btn_primary_new_v w_fit_content md' onClick={showModal}>
                                                        <span>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                <path d="M8 3.33334V12.6667" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M3.33325 8H12.6666" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                            Add Inventory
                                                        </span>
                                                    </button>

                                                    <Dropdown ref={dropdownRef} show={filterShow}
                                                        onToggle={() => { setFilterShow(!filterShow) }}
                                                        className="" autoClose={false}>
                                                        {
                                                            filter === "web" ?
                                                                <div className="position-relative hover_effec_hide_show_d2">
                                                                    <Dropdown.Toggle id="dropdown-autoclose-false" className="" style={{ padding: '0px 1.1rem' }}>
                                                                        <Button className="" icon={
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                <path d="M12.5611 2H1.44995L5.8944 7.25556V10.8889L8.11662 12V7.25556L12.5611 2Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </svg>
                                                                        }>
                                                                            Filter
                                                                            {(filterApplyApiCall?.status?.length + filterApplyApiCall?.iab?.length + filterApplyApiCall?.trafficType?.length + filterApplyApiCall?.inventoryProvider?.length + filterApplyApiCall?.riskType?.length + filterApplyApiCall?.publisher?.length + filterApplyApiCall?.brandRiskFloorFree?.length + filterApplyApiCall?.mfaRisk?.length) > 0 &&
                                                                                <div className="selected_filter_tag_d2">
                                                                                    <div>

                                                                                        <>
                                                                                            {filterApplyApiCall?.status?.length + filterApplyApiCall?.iab?.length + filterApplyApiCall?.trafficType?.length + filterApplyApiCall?.inventoryProvider?.length + filterApplyApiCall?.riskType?.length + filterApplyApiCall?.publisher?.length + filterApplyApiCall?.brandRiskFloorFree?.length + filterApplyApiCall?.mfaRisk?.length}
                                                                                        </>

                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </Button>

                                                                    </Dropdown.Toggle>
                                                                    {(filterApplyApiCall?.status?.length + filterApplyApiCall?.iab?.length + filterApplyApiCall?.trafficType?.length + filterApplyApiCall?.inventoryProvider?.length + filterApplyApiCall?.riskType?.length + filterApplyApiCall?.publisher?.length + filterApplyApiCall?.brandRiskFloorFree?.length + filterApplyApiCall?.mfaRisk?.length) > 0 &&
                                                                        <div className="clear_filter_icon_d2" style={{ right: '1.7rem', top: '0.8rem' }}>
                                                                            <button type="button"> <img src={HoverCloseIcon} alt=""
                                                                                onClick={() => {
                                                                                    setFilterApplyByTab(prev => ({ ...prev, [filter]: emptyFilter() }))
                                                                                    setLoading(true)
                                                                                    setFilterApplyApiCallByTab(prev => ({ ...prev, [filter]: emptyFilter() }))
                                                                                    setFilterShow(false)
                                                                                }} />
                                                                            </button>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                :
                                                                filter === "ctv" ?
                                                                    <div className="position-relative hover_effec_hide_show_d2">
                                                                        <Dropdown.Toggle id="dropdown-autoclose-false" style={{ padding: '0px 1.1rem' }}>
                                                                            <Button className="" icon={
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                    <path d="M12.5611 2H1.44995L5.8944 7.25556V10.8889L8.11662 12V7.25556L12.5611 2Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                </svg>
                                                                            }>
                                                                                Filter
                                                                                {(filterApplyApiCall?.status?.length + filterApplyApiCall?.inventoryProvider?.length + filterApplyApiCall?.riskType?.length + filterApplyApiCall?.publisher?.length + filterApplyApiCall?.brandRiskFloorFree?.length) > 0 &&
                                                                                    <div className="selected_filter_tag_d2">
                                                                                        <div>

                                                                                            <>
                                                                                                {filterApplyApiCall?.status?.length + filterApplyApiCall?.inventoryProvider?.length + filterApplyApiCall?.publisher?.length + filterApplyApiCall?.brandRiskFloorFree?.length}
                                                                                            </>

                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            </Button>

                                                                        </Dropdown.Toggle>
                                                                        {(filterApplyApiCall?.status?.length + filterApplyApiCall?.inventoryProvider?.length + filterApplyApiCall?.riskType?.length + filterApplyApiCall?.publisher?.length + filterApplyApiCall?.brandRiskFloorFree?.length) > 0 &&
                                                                            <div className="clear_filter_icon_d2" style={{ right: '1.7rem', top: '0.8rem' }}>
                                                                                <button type="button"> <img src={HoverCloseIcon} alt=""
                                                                                    onClick={() => {
                                                                                        setFilterApplyByTab(prev => ({ ...prev, [filter]: emptyFilter() }))
                                                                                        setFilterApplyApiCallByTab(prev => ({ ...prev, [filter]: emptyFilter() }))
                                                                                        setFilterShow(false)
                                                                                    }} />
                                                                                </button>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    :
                                                                    <div className="position-relative hover_effec_hide_show_d2">
                                                                        <Dropdown.Toggle id="dropdown-autoclose-false" style={{ padding: '0px 1.1rem' }}>
                                                                            <Button className="" icon={
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                    <path d="M12.5611 2H1.44995L5.8944 7.25556V10.8889L8.11662 12V7.25556L12.5611 2Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                </svg>
                                                                            }>
                                                                                Filter
                                                                                {(filterApplyApiCall?.status?.length + filterApplyApiCall?.trafficType?.length + filterApplyApiCall?.inventoryProvider?.length + filterApplyApiCall?.publisher?.length + filterApplyApiCall?.brandRiskFloorFree?.length) > 0 &&
                                                                                    <div className="selected_filter_tag_d2">
                                                                                        <div>

                                                                                            <>
                                                                                                {filterApplyApiCall?.status?.length + filterApplyApiCall?.trafficType?.length + filterApplyApiCall?.inventoryProvider?.length + filterApplyApiCall?.publisher?.length + filterApplyApiCall?.brandRiskFloorFree?.length}
                                                                                            </>

                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                            </Button>

                                                                        </Dropdown.Toggle>
                                                                        {(filterApplyApiCall?.status?.length + filterApplyApiCall?.trafficType?.length + filterApplyApiCall?.inventoryProvider?.length + filterApplyApiCall?.publisher?.length + filterApplyApiCall?.brandRiskFloorFree?.length) > 0 &&
                                                                            <div className="clear_filter_icon_d2" style={{ right: '1.7rem', top: '0.8rem' }}>
                                                                                <button type="button"> <img src={HoverCloseIcon} alt=""
                                                                                    onClick={() => {
                                                                                        setFilterApplyByTab(prev => ({ ...prev, [filter]: emptyFilter() }))
                                                                                        setFilterApplyApiCallByTab(prev => ({ ...prev, [filter]: emptyFilter() }))
                                                                                        setFilterShow(false)
                                                                                    }} />
                                                                                </button>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                        }
                                                        <Dropdown.Menu>
                                                            <div className="filter_inner_heading_d2">
                                                                {(checkRole !== "admin" && checkRole !== "u_admin") &&
                                                                    <>
                                                                        <div className="d-flex align-items-start justify-content-between">
                                                                            <p className="m-0">Publisher</p>
                                                                            <button type="button" className="filter_clear_btn"
                                                                                onClick={() => {
                                                                                    setFilterApplyByTab(prev => ({ ...prev, [filter]: { ...prev[filter], publisher: [] } }))
                                                                                }}
                                                                            >Reset</button>
                                                                        </div>
                                                                        <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100">
                                                                            <Select
                                                                                id="adcodeSelect"
                                                                                value={filterApply.publisher}
                                                                                popupClassName='diff_select_d2'
                                                                                // open={true}
                                                                                showSearch={false}
                                                                                placeholder='- Select -'
                                                                                className="form_select basic error"
                                                                                mode='multiple'
                                                                                maxTagCount='responsive'
                                                                                onDropdownVisibleChange={handleDropdownVisibleChange1}


                                                                                dropdownRender={menu => (
                                                                                    <>
                                                                                        <div className="custom_inside_searchbar_d2">
                                                                                            <Input placeholder="Search" ref={searchInputRef1} value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                        </div>
                                                                                        {menu}
                                                                                    </>
                                                                                )}
                                                                            >
                                                                                {filteredOptions.map(option => (
                                                                                    <Option key={option.value} value={option.value}>
                                                                                        <div
                                                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                                        >
                                                                                            <Checkbox
                                                                                                checked={filterApply.publisher?.includes(option.value)}
                                                                                                onClick={(e) => e.stopPropagation()}
                                                                                            >
                                                                                                {option.label}
                                                                                            </Checkbox>
                                                                                        </div>
                                                                                    </Option>
                                                                                ))}
                                                                            </Select>
                                                                        </div>
                                                                        <hr />
                                                                    </>
                                                                }


                                                                {/* {filter === "web" &&
                                                                    <>
                                                                        <div className="d-flex align-items-start justify-content-between">
                                                                            <p className="m-0">IAB Primary Categories</p>
                                                                            <button type="button" className="filter_clear_btn"
                                                                                onClick={() => {
                                                                                    setFilterApplyByTab(prev => ({ ...prev, [filter]: { ...prev[filter], iab: [] } }))
                                                                                }}
                                                                            >Reset</button>
                                                                        </div>
                                                                        <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100">
                                                                            <Select
                                                                                id="adcodeSelect2"
                                                                                value={filterApply.iab}
                                                                                popupClassName='diff_select_d2'
                                                                                // open={true}
                                                                                showSearch={false}
                                                                                placeholder='- Select -'
                                                                                className="form_select basic error"
                                                                                mode='multiple'
                                                                                maxTagCount='responsive'
                                                                                onDropdownVisibleChange={handleDropdownVisibleChange2}


                                                                                dropdownRender={menu => (
                                                                                    <>
                                                                                        <div className="custom_inside_searchbar_d2">
                                                                                            <Input placeholder="Search" ref={searchInputRef2} value={searchValue2} onChange={handleSearch2} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                        </div>
                                                                                        {menu}
                                                                                    </>
                                                                                )}
                                                                            >
                                                                                {filteredOptions2.map(option => (
                                                                                    <Option key={option.value} value={option.value}>
                                                                                        <div
                                                                                            onClick={() => handleFilterApply("iab", option.value)}
                                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                                        >
                                                                                            <Checkbox
                                                                                                checked={filterApply.iab?.includes(option.value)}
                                                                                                onClick={(e) => e.stopPropagation()}
                                                                                            >
                                                                                                {option.label}
                                                                                            </Checkbox>
                                                                                        </div>
                                                                                    </Option>
                                                                                ))}
                                                                            </Select>
                                                                        </div>
                                                                        <hr />
                                                                    </>
                                                                } */}


                                                                <p className="m-0">Status</p>
                                                                <div className="checkbox_value_select_d2">
                                                                    <div className="checkbox_active_design_d2">
                                                                        <input type="checkbox" name="statusapproved" id="statusapproved"
                                                                            checked={filterApply.status.includes("approved")}
                                                                            onChange={() => { handleFilterApply("status", "approved") }}
                                                                        />
                                                                        <label htmlFor="statusapproved" className="single_checkbox_select_d2">
                                                                            Approved
                                                                        </label>
                                                                    </div>
                                                                    <div className="checkbox_active_design_d2">
                                                                        <input type="checkbox" name="statuspending" id="statuspending"
                                                                            checked={filterApply.status.includes("pending")}
                                                                            onChange={() => { handleFilterApply("status", "pending") }}
                                                                        />
                                                                        <label htmlFor="statuspending" className="single_checkbox_select_d2">
                                                                            Pending
                                                                        </label>
                                                                    </div>
                                                                    <div className="checkbox_active_design_d2">
                                                                        <input type="checkbox" name="statusrejected" id="statusrejected"
                                                                            checked={filterApply.status.includes("rejected")}
                                                                            onChange={() => { handleFilterApply("status", "rejected") }}
                                                                        />
                                                                        <label htmlFor="statusrejected" className="single_checkbox_select_d2">
                                                                            Rejected
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                {/* 

                                                                {filter === "web" &&
                                                                    <>
                                                                        <hr />

                                                                        <p className="m-0">Risk Type</p>
                                                                        <div className="checkbox_value_select_d2">
                                                                            <div className="checkbox_active_design_d2">
                                                                                <input type="checkbox" name="riskTypeLow" id="riskTypeLow"
                                                                                    checked={filterApply.riskType.includes("low")}
                                                                                    onChange={() => { handleFilterApply("riskType", "low") }}
                                                                                />
                                                                                <label htmlFor="riskTypeLow" className="single_checkbox_select_d2">
                                                                                    Low
                                                                                </label>
                                                                            </div>
                                                                            <div className="checkbox_active_design_d2">
                                                                                <input type="checkbox" name="riskTypeMedium" id="riskTypeMedium"
                                                                                    checked={filterApply.riskType.includes("medium")}
                                                                                    onChange={() => { handleFilterApply("riskType", "medium") }}
                                                                                />
                                                                                <label htmlFor="riskTypeMedium" className="single_checkbox_select_d2">
                                                                                    Medium
                                                                                </label>
                                                                            </div>
                                                                            <div className="checkbox_active_design_d2">
                                                                                <input type="checkbox" name="riskTypeHigh" id="riskTypeHigh"
                                                                                    checked={filterApply.riskType.includes("high")}
                                                                                    onChange={() => { handleFilterApply("riskType", "high") }}
                                                                                />
                                                                                <label htmlFor="riskTypeHigh" className="single_checkbox_select_d2">
                                                                                    High
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                } */}

                                                                <hr />

                                                                <p className="m-0">Inventory Provider</p>
                                                                <div className="checkbox_value_select_d2">
                                                                    <div className="checkbox_active_design_d2">
                                                                        <input type="checkbox" name="inventoryProviderO&O" id="inventoryProviderO&O"
                                                                            checked={filterApply.inventoryProvider.includes("O&O")}
                                                                            onChange={() => { handleFilterApply("inventoryProvider", "O&O") }}
                                                                        />
                                                                        <label htmlFor="inventoryProviderO&O" className="single_checkbox_select_d2">
                                                                            O&O
                                                                        </label>
                                                                    </div>
                                                                    <div className="checkbox_active_design_d2">
                                                                        <input type="checkbox" name="inventoryProviderResold" id="inventoryProviderResold"
                                                                            checked={filterApply.inventoryProvider.includes("Resold")}
                                                                            onChange={() => { handleFilterApply("inventoryProvider", "Resold") }}
                                                                        />
                                                                        <label htmlFor="inventoryProviderResold" className="single_checkbox_select_d2">
                                                                            Resold
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                <hr />

                                                                <p className="m-0">Brand Risk Floor Free</p>
                                                                <div className="checkbox_value_select_d2">
                                                                    <div className="checkbox_active_design_d2">
                                                                        <input type="checkbox" name="brandRiskFloorFreeNoRisk" id="brandRiskFloorFreeNoRisk"
                                                                            checked={filterApply.brandRiskFloorFree.includes("risk_free")}
                                                                            onChange={() => { handleFilterApply("brandRiskFloorFree", "risk_free") }}
                                                                        />
                                                                        <label htmlFor="brandRiskFloorFreeNoRisk" className="single_checkbox_select_d2">
                                                                            No Risk
                                                                        </label>
                                                                    </div>
                                                                    <div className="checkbox_active_design_d2">
                                                                        <input type="checkbox" name="brandRiskFloorFreeWithRisk" id="brandRiskFloorFreeWithRisk"
                                                                            checked={filterApply.brandRiskFloorFree.includes("has_risk")}
                                                                            onChange={() => { handleFilterApply("brandRiskFloorFree", "has_risk") }}
                                                                        />
                                                                        <label htmlFor="brandRiskFloorFreeWithRisk" className="single_checkbox_select_d2">
                                                                            With Risk
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                {filter === "web" &&
                                                                    <>
                                                                        <hr />

                                                                        <p className="m-0">MFA Risk</p>
                                                                        <div className="checkbox_value_select_d2">
                                                                            <div className="checkbox_active_design_d2">
                                                                                <input type="checkbox" name="mfaRiskNoRisk" id="mfaRiskNoRisk"
                                                                                    checked={filterApply.mfaRisk.includes("risk_free")}
                                                                                    onChange={() => { handleFilterApply("mfaRisk", "risk_free") }}
                                                                                />
                                                                                <label htmlFor="mfaRiskNoRisk" className="single_checkbox_select_d2">
                                                                                    No Risk
                                                                                </label>
                                                                            </div>
                                                                            <div className="checkbox_active_design_d2">
                                                                                <input type="checkbox" name="mfaRiskWithRisk" id="mfaRiskWithRisk"
                                                                                    checked={filterApply.mfaRisk.includes("has_risk")}
                                                                                    onChange={() => { handleFilterApply("mfaRisk", "has_risk") }}
                                                                                />
                                                                                <label htmlFor="mfaRiskWithRisk" className="single_checkbox_select_d2">
                                                                                    With Risk
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                }

                                                                {filter !== "ctv" &&
                                                                    <>
                                                                        <hr />

                                                                        <p className="m-0">Traffic Type</p>
                                                                        <div className="checkbox_value_select_d2">
                                                                            <div className="checkbox_active_design_d2">
                                                                                <input type="checkbox" name="trafficTypeBanner" id="trafficTypeBanner"
                                                                                    checked={filterApply.trafficType.includes("Banner")}
                                                                                    onChange={() => { handleFilterApply("trafficType", "Banner") }}
                                                                                />
                                                                                <label htmlFor="trafficTypeBanner" className="single_checkbox_select_d2">
                                                                                    Banner
                                                                                </label>
                                                                            </div>
                                                                            <div className="checkbox_active_design_d2">
                                                                                <input type="checkbox" name="trafficTypeNative" id="trafficTypeNative"
                                                                                    checked={filterApply.trafficType.includes("Native")}
                                                                                    onChange={() => { handleFilterApply("trafficType", "Native") }}
                                                                                />
                                                                                <label htmlFor="trafficTypeNative" className="single_checkbox_select_d2">
                                                                                    Native
                                                                                </label>
                                                                            </div>
                                                                            <div className="checkbox_active_design_d2">
                                                                                <input type="checkbox" name="trafficTypeVideo" id="trafficTypeVideo"
                                                                                    checked={filterApply.trafficType.includes("Video")}
                                                                                    onChange={() => { handleFilterApply("trafficType", "Video") }}
                                                                                />
                                                                                <label htmlFor="trafficTypeVideo" className="single_checkbox_select_d2">
                                                                                    Video
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                }
                                                                <hr />
                                                            </div>
                                                            <div className="filter_bottom_btns_d2 text-end">
                                                                <button className="reset" type='button' onClick={() => {
                                                                    setFilterApplyByTab(prev => ({ ...prev, [filter]: emptyFilter() }))
                                                                    setLoading(true)
                                                                    setFilterApplyApiCallByTab(prev => ({ ...prev, [filter]: emptyFilter() }))
                                                                    setFilterShow(false)
                                                                    setSearchValue('')
                                                                }}>Reset</button>
                                                                <button className="apply" type='button'
                                                                    onClick={() => {
                                                                        let tempdata = JSON.parse(JSON.stringify(filterApply));
                                                                        setLoading(true)
                                                                        setFilterApplyApiCallByTab(prev => ({ ...prev, [filter]: tempdata }))
                                                                        setFilterShow(false)
                                                                        setSearchValue('')
                                                                    }}
                                                                    disabled={JSON.stringify(filterApplyApiCall) === JSON.stringify(filterApply)}
                                                                >Apply</button>
                                                            </div>
                                                        </Dropdown.Menu>
                                                    </Dropdown>

                                                    <div className="column_hide_unhide_d3 column_hide_unhide_mediaplanner_d2">
                                                        <Dropdown className="" autoClose="outside">
                                                            <Dropdown.Toggle id="dropdown-autoclose-outside" className="">
                                                                <Button className="" icon={
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                        <path d="M1.5 3H5.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M8.5 3H12.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M1.5 7H5.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M8.5 7H12.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M1.5 11H5.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M8.5 11H12.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                }>
                                                                    Columns
                                                                </Button>
                                                            </Dropdown.Toggle>
                                                            {filter === "web" ?
                                                                <Dropdown.Menu>
                                                                    <div className="colunm_checkbox">
                                                                        <ul className="p-0 m-0">
                                                                            <li>
                                                                                <label htmlFor="select_all_adcodes">
                                                                                    <input
                                                                                        className={isIndeterminate(colvisWeb) ? "form-check-input parital_checkbox" : "form-check-input"}
                                                                                        type="checkbox"
                                                                                        id="select_all_adcodes"
                                                                                        checked={Object.values(colvisWeb).every(value => value === true)}
                                                                                        onChange={(e) => {
                                                                                            const updatedObj = Object.keys(colvisWeb).reduce((acc, key) => {
                                                                                                acc[key] = e.target.checked;
                                                                                                return acc;
                                                                                            }, {});

                                                                                            setColvisWeb(updatedObj);
                                                                                        }}
                                                                                    />
                                                                                    <span>
                                                                                        < >Select All</>
                                                                                    </span>
                                                                                </label>
                                                                            </li>
                                                                            <hr className="new_item_line_d3" />
                                                                        </ul>
                                                                        <ul
                                                                            className="p-0 m-0 colvis_scroll">
                                                                            <Row >
                                                                                {filterRepeaterValueOptions_colvisWeb.map(({ label, value }) => (
                                                                                    <Col span={8}>
                                                                                        <li key={value}>
                                                                                            <label htmlFor={value}>
                                                                                                <input
                                                                                                    className="form-check-input"
                                                                                                    type="checkbox"
                                                                                                    id={value}
                                                                                                    checked={colvisWeb[value]}
                                                                                                    onChange={() => {
                                                                                                        const tempData = { ...colvisWeb };
                                                                                                        tempData[value] = !tempData[value];
                                                                                                        setColvisWeb(tempData);
                                                                                                    }}
                                                                                                />
                                                                                                <span> {label?.length >= 50 ?
                                                                                                    <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                                                                    < >{label}</>}
                                                                                                </span>
                                                                                            </label>
                                                                                        </li>
                                                                                    </Col>
                                                                                ))}
                                                                            </Row>
                                                                            <Row>
                                                                                <hr className="new_item_line_d3" />
                                                                                <Col span={24}>
                                                                                    <li>
                                                                                        <label>
                                                                                            <h5> Supply Lens
                                                                                            </h5>
                                                                                        </label>
                                                                                    </li>
                                                                                </Col>
                                                                                {filterRepeaterValueOptions_colvisWebSupplyLens.map(({ label, value }) => (
                                                                                    <Col span={8}>
                                                                                        <li key={value}>
                                                                                            <label htmlFor={value}>
                                                                                                <input
                                                                                                    className="form-check-input"
                                                                                                    type="checkbox"
                                                                                                    id={value}
                                                                                                    checked={colvisWeb[value]}
                                                                                                    onChange={() => {
                                                                                                        const tempData = { ...colvisWeb };
                                                                                                        tempData[value] = !tempData[value];
                                                                                                        setColvisWeb(tempData);
                                                                                                    }}
                                                                                                />
                                                                                                <span> {label?.length >= 50 ?
                                                                                                    <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                                                                    < >{label}</>}
                                                                                                </span>
                                                                                            </label>
                                                                                        </li>
                                                                                    </Col>
                                                                                ))}
                                                                            </Row>
                                                                        </ul>
                                                                    </div>
                                                                </Dropdown.Menu>
                                                                :
                                                                filter === "mobile" ?
                                                                    <Dropdown.Menu>
                                                                        <div className="colunm_checkbox">
                                                                            <ul className="p-0 m-0">
                                                                                <li>
                                                                                    <label htmlFor="select_all_adcodes">
                                                                                        <input
                                                                                            className={isIndeterminate(colvisMobile) ? "form-check-input parital_checkbox" : "form-check-input"}
                                                                                            type="checkbox"
                                                                                            id="select_all_adcodes"
                                                                                            checked={Object.values(colvisMobile).every(value => value === true)}
                                                                                            onChange={(e) => {
                                                                                                const updatedObj = Object.keys(colvisMobile).reduce((acc, key) => {
                                                                                                    acc[key] = e.target.checked;
                                                                                                    return acc;
                                                                                                }, {});

                                                                                                setColvisMobile(updatedObj);
                                                                                            }}
                                                                                        />
                                                                                        <span>
                                                                                            < >Select All</>
                                                                                        </span>
                                                                                    </label>
                                                                                </li>
                                                                                <hr className="new_item_line_d3" />

                                                                            </ul>
                                                                            <ul
                                                                                className="p-0 m-0 colvis_scroll"
                                                                            >
                                                                                <Row >
                                                                                    {filterRepeaterValueOptions_colvisMobile.map(({ label, value }) => (
                                                                                        <Col span={8}>
                                                                                            <li key={value}>
                                                                                                <label htmlFor={value}>
                                                                                                    <input
                                                                                                        className="form-check-input"
                                                                                                        type="checkbox"
                                                                                                        id={value}
                                                                                                        checked={colvisMobile[value]}
                                                                                                        onChange={() => {
                                                                                                            const tempData = { ...colvisMobile };
                                                                                                            tempData[value] = !tempData[value];
                                                                                                            setColvisMobile(tempData);
                                                                                                        }}
                                                                                                    />
                                                                                                    <span> {label?.length >= 50 ?
                                                                                                        <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                                                                        < >{label}</>}
                                                                                                    </span>
                                                                                                </label>
                                                                                            </li>
                                                                                        </Col>
                                                                                    ))}
                                                                                    <hr className="new_item_line_d3" />
                                                                                    <Col span={24}>
                                                                                        <li>
                                                                                            <label>
                                                                                                <h5> Supply Lens
                                                                                                </h5>
                                                                                            </label>
                                                                                        </li>
                                                                                    </Col>
                                                                                    {filterRepeaterValueOptions_colvisMobileSupplyLens.map(({ label, value }) => (
                                                                                        <Col span={8}>
                                                                                            <li key={value}>
                                                                                                <label htmlFor={value}>
                                                                                                    <input
                                                                                                        className="form-check-input"
                                                                                                        type="checkbox"
                                                                                                        id={value}
                                                                                                        checked={colvisMobile[value]}
                                                                                                        onChange={() => {
                                                                                                            const tempData = { ...colvisMobile };
                                                                                                            tempData[value] = !tempData[value];
                                                                                                            setColvisMobile(tempData);
                                                                                                        }}
                                                                                                    />
                                                                                                    <span> {label?.length >= 50 ?
                                                                                                        <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                                                                        < >{label}</>}
                                                                                                    </span>
                                                                                                </label>
                                                                                            </li>
                                                                                        </Col>
                                                                                    ))}
                                                                                </Row>

                                                                            </ul>
                                                                        </div>

                                                                    </Dropdown.Menu>

                                                                    :

                                                                    filter === "ctv" ?
                                                                        <Dropdown.Menu>
                                                                            <div className="colunm_checkbox">
                                                                                <ul className="p-0 m-0"

                                                                                >
                                                                                    <li
                                                                                    >
                                                                                        <label htmlFor="select_all_adcodes">
                                                                                            <input
                                                                                                className={isIndeterminate(colvisCtv) ? "form-check-input parital_checkbox" : "form-check-input"}
                                                                                                type="checkbox"
                                                                                                id="select_all_adcodes"
                                                                                                checked={Object.values(colvisCtv).every(value => value === true)}
                                                                                                onChange={(e) => {
                                                                                                    const updatedObj = Object.keys(colvisCtv).reduce((acc, key) => {
                                                                                                        acc[key] = e.target.checked;
                                                                                                        return acc;
                                                                                                    }, {});

                                                                                                    setColvisCtv(updatedObj);
                                                                                                }}
                                                                                            />
                                                                                            <span>
                                                                                                < >Select All</>
                                                                                            </span>
                                                                                        </label>
                                                                                    </li>
                                                                                    <hr className="new_item_line_d3" />

                                                                                </ul>
                                                                                <ul
                                                                                    className="p-0 m-0 colvis_scroll"
                                                                                >
                                                                                    <Row >
                                                                                        {filterRepeaterValueOptions_colvisCtv.map(({ label, value }) => (
                                                                                            <Col span={8}>
                                                                                                <li key={value}>
                                                                                                    <label htmlFor={value}>
                                                                                                        <input
                                                                                                            className="form-check-input"
                                                                                                            type="checkbox"
                                                                                                            id={value}
                                                                                                            checked={colvisCtv[value]}
                                                                                                            onChange={() => {
                                                                                                                const tempData = { ...colvisCtv };
                                                                                                                tempData[value] = !tempData[value];
                                                                                                                setColvisCtv(tempData);
                                                                                                            }}
                                                                                                        />
                                                                                                        <span> {label?.length >= 50 ?
                                                                                                            <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                                                                            < >{label}</>}
                                                                                                        </span>
                                                                                                    </label>
                                                                                                </li>
                                                                                            </Col>
                                                                                        ))}
                                                                                        <hr className="new_item_line_d3" />
                                                                                        <Col span={24}>
                                                                                            <li>
                                                                                                <label>
                                                                                                    <h5> Supply Lens
                                                                                                    </h5>
                                                                                                </label>
                                                                                            </li>
                                                                                        </Col>
                                                                                        {filterRepeaterValueOptions_colvisCtvSupplyLens.map(({ label, value }) => (
                                                                                            <Col span={8}>
                                                                                                <li key={value}>
                                                                                                    <label htmlFor={value}>
                                                                                                        <input
                                                                                                            className="form-check-input"
                                                                                                            type="checkbox"
                                                                                                            id={value}
                                                                                                            checked={colvisCtv[value]}
                                                                                                            onChange={() => {
                                                                                                                const tempData = { ...colvisCtv };
                                                                                                                tempData[value] = !tempData[value];
                                                                                                                setColvisCtv(tempData);
                                                                                                            }}
                                                                                                        />
                                                                                                        <span> {label?.length >= 50 ?
                                                                                                            <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                                                                            < >{label}</>}
                                                                                                        </span>
                                                                                                    </label>
                                                                                                </li>
                                                                                            </Col>
                                                                                        ))}
                                                                                    </Row>

                                                                                </ul>
                                                                            </div>

                                                                        </Dropdown.Menu>
                                                                        :
                                                                        <></>
                                                            }
                                                        </Dropdown>
                                                    </div>

                                                    {/* {filter === "all" && */}
                                                    <div className="export_btn_hover_d2">
                                                        {data.length === 0 ?
                                                            <Button className="export_btn_d2"
                                                                icon={
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                        <g clip-path="url(#clip0_11006_24214)">
                                                                            <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                            <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                            <path d="M7 8.75V1.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_11006_24214">
                                                                                <rect width="14" height="14" fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                }>
                                                                Export
                                                            </Button>
                                                            :
                                                            <>
                                                                {exportLoading ?
                                                                    <Button className="export_btn_d2"
                                                                        icon={
                                                                            <img
                                                                                src={FullLoader}
                                                                                alt="USP"
                                                                                height={15}
                                                                                width={15}
                                                                                className="loader_icon"
                                                                            />
                                                                        }
                                                                    >
                                                                        Export
                                                                    </Button>
                                                                    :
                                                                    <Button
                                                                        className="export_btn_d2"
                                                                        onClick={getDataExport}
                                                                        icon={
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                <g clip-path="url(#clip0_11006_24214)">
                                                                                    <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    <path d="M7 8.75V1.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                                </g>
                                                                                <defs>
                                                                                    <clipPath id="clip0_11006_24214">
                                                                                        <rect width="14" height="14" fill="white" />
                                                                                    </clipPath>
                                                                                </defs>
                                                                            </svg>
                                                                        }>
                                                                        Export
                                                                    </Button>
                                                                }
                                                            </>
                                                        }
                                                    </div>
                                                    {/* } */}

                                                </div>
                                            </>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                        <div className="table_content--box no_data_screen_view table_checkbox_design_cls">
                            {loading && !initialLoad &&
                                <div className="table_new_loader_d2">
                                    <img src={FullLoader} className="img-fluid" alt="" />
                                </div>
                            }
                            {initialLoad || tabLoad ?
                                <TableLoader />
                                :
                                <div className='table_content--box --new_layout_table_design table_empty_screen_d2 user_sync_table_v2 no_data_screen_view table_input_design_cls'>
                                    {filter === "web" ?
                                        <Form form={form} component={false}>

                                            <Table
                                                // onRow={(record) => ({
                                                //     onClick: () => {
                                                //         if (editingKey) return;
                                                //     },
                                                // })}
                                                rowKey={(record) => record._id}
                                                rowSelection={(checkRole === "admin" || checkRole === "u_admin") ? false : rowSelection}
                                                components={
                                                    editingKey
                                                        ? { body: { cell: EditableCell } }
                                                        : undefined
                                                }
                                                className="custom-ant-table"
                                                columns={mergedColumnsWebsite}
                                                // sticky
                                                pageSize={100}
                                                dataSource={data}
                                                onChange={handleTableChange}
                                                rowClassName={(record) =>
                                                    record._id === editingKey ? "row_editing" : ""
                                                }
                                                locale={locale}
                                                pagination={false}

                                                // rowKey={(record) => record.id}
                                                showSorterTooltip={false}
                                                scroll={{ x: data.length === 0 ? '2600' : 'max-content', y: 'calc(100vh - 40rem' }} />
                                        </Form>


                                        :

                                        filter === "ctv" ?
                                            <Form form={form} component={false}>
                                                <Table
                                                    rowKey={(record) => record._id}
                                                    rowSelection={(checkRole === "admin" || checkRole === "u_admin") ? false : rowSelection}
                                                    components={
                                                        editingKey
                                                            ? { body: { cell: EditableCell } }
                                                            : undefined
                                                    }
                                                    // sticky
                                                    className="custom-ant-table"
                                                    columns={mergedColumnsCTV}
                                                    pageSize={100}
                                                    dataSource={data}
                                                    onChange={handleTableChange}
                                                    showSorterTooltip={false}
                                                    locale={locale}
                                                    pagination={false}
                                                    rowClassName={(record) =>
                                                        record._id === editingKey ? "row_editing" : ""
                                                    }
                                                    // rowKey={(record) => record.id}
                                                    scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 37.3rem' }} />
                                            </Form>
                                            :
                                            <Form form={form} component={false}>
                                                <Table
                                                    rowKey={(record) => record._id}
                                                    rowSelection={(checkRole === "admin" || checkRole === "u_admin") ? false : rowSelection}
                                                    components={
                                                        editingKey
                                                            ? { body: { cell: EditableCell } }
                                                            : undefined
                                                    }
                                                    className="custom-ant-table"
                                                    columns={mergedColumnsMobile}
                                                    pageSize={100}
                                                    dataSource={data}
                                                    onChange={handleTableChange}
                                                    rowClassName={(record) =>
                                                        record._id === editingKey ? "row_editing" : ""
                                                    }
                                                    showSorterTooltip={false}
                                                    locale={locale}
                                                    pagination={false}
                                                    // rowKey={(record) => record.id}
                                                    scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 37.3rem' }} />
                                            </Form>



                                    }
                                </div>
                            }

                            {data.length > 0 && !tabLoad &&
                                <Row className="custom_pagination--container">
                                    <Col span={6}>
                                        <div className="form_content_block--group mb_0">
                                            <Select
                                                className='form_select basic sm no_search'
                                                value={page.pageSize}
                                                onChange={handlePageSizeChange}
                                                style={{ width: 80 }}
                                                showSearch={false}
                                                options={[
                                                    { value: 10, label: 10 },
                                                    { value: 20, label: 20 },
                                                    { value: 50, label: 50 },
                                                    { value: 100, label: 100 },
                                                ]} />
                                            <label className='custom_pagination--label'>
                                                items per page
                                            </label>
                                        </div>
                                    </Col>
                                    <Col span={6}>
                                        <span className="custom_pagination--total-text">
                                            {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                        </span>
                                    </Col>
                                    <Col span={6}>
                                        <Pagination
                                            current={page.current}  // Pass individual props instead of spreading them
                                            pageSize={page.pageSize}
                                            total={page.total}
                                            onChange={handlePageChange}
                                            showSizeChanger={false}
                                            itemRender={itemRender}
                                            className="custom_pagination" />
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div>
                </div>
            </div >

            <div >
                <Modal
                    className='custom_modal custom_modal_form_d2'
                    maskClosable={false}
                    title={
                        <div className='custom_modal--header border-0'><h3 className='heading'>
                            <img src={LinkIcon} alt='USP' />

                            {filter === "web" ?
                                <>Add Domains</>
                                :
                                filter === "ctv" ?
                                    <>Add CTV Apps</>
                                    :
                                    <>Add Mobile Apps</>

                            }
                        </h3>
                        </div>
                    }
                    width={1400}
                    closable={{ 'aria-label': 'Custom Close Button' }}
                    open={isModalOpen}
                    // onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[
                        <div className="custom_modal--footer d_flex justify_content_between publisher_domain_upload_footer">
                            <div className="d_flex justify_content_start align_items_center">

                            </div>
                            <div className="btn_group justify-content-end gap_8">
                                {buttonProcessing ?
                                    <button className="w_120_d2 btn btn_primary w_fit_content">Processing...</button> :
                                    <button className="w_120_d2 btn btn_primary w_fit_content" onClick={handleSubmit}>Submit</button>
                                }
                            </div>
                        </div>
                    ]}>
                    <div className="custom_tabs_wrapper">
                        <div className="custom_tabs">
                            <div className={`custom_tab ${activeTab === "tab1" ? "active" : ""}`} onClick={() => setActiveTab("tab1")}>
                                Manual Entry
                            </div>
                            <div className={`custom_tab ${activeTab === "tab2" ? "active" : ""}`} onClick={() => setActiveTab("tab2")}>
                                Bulk Upload
                            </div>
                        </div>

                        {/* Tabs content */}
                        <div className="custom_tab_content">
                            {activeTab === "tab1" && <div>
                                <div className="custom_modal--body">
                                    <div className="tab_content--body">

                                        {(checkRole !== "admin" && checkRole !== "u_admin") &&
                                            <div className="form_content_block--group modal_form_bottom_gap_d2 w-25 mb-4 ">
                                                <label className="form_label">Publisher*</label>
                                                <Select
                                                    showSearch={true}
                                                    optionLabelProp="label"
                                                    className='form_select basic --without_search_icon_select'
                                                    placeholder="-Select-"
                                                    // open={true}
                                                    options={publisherList}
                                                    onChange={onChangePublisher}
                                                    value={selectedPublisher}
                                                />
                                                <span className="error_content">
                                                    {publisherIsRequiredError && (
                                                        <> This field is required</>
                                                    )}
                                                </span>
                                            </div>
                                        }

                                        <div className="form_content_block--group modal_form_bottom_gap_d2 w-25">
                                            <label className="form_label">Platform Type</label>
                                            <Select
                                                showSearch={false}
                                                disabled
                                                // disabled={dataSource.length > 0}
                                                value={inventoryTypeTab1}
                                                onChange={(event) => { setInventoryTypeTab1(event) }}
                                                optionLabelProp="label"
                                                className='form_select basic'
                                                placeholder="-Select-">
                                                <Option value="Website">Website</Option>
                                                <Option value="CTV">CTV</Option>
                                                <Option value="Mobile App">Mobile App</Option>

                                            </Select>
                                        </div>
                                        <div className='modal_table_design'>
                                            <div className='table_content--box --new_layout_table_design table_empty_screen_d2 no_data_screen_view table_input_design_cls'>
                                                <div className="inventory-table-wrapper">
                                                    <Table
                                                        columns={columns}
                                                        dataSource={dataSource}
                                                        pagination={false}
                                                        scroll={{ x: "max-content", y: dataSource.length === 0 ? "0px" : "300px" }}
                                                        locale={{ emptyText: null }}
                                                    />
                                                    <Button type="text" icon={<PlusOutlined />} className="add_more_btn" onClick={addRow}>
                                                        Add more
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {activeTab === "tab2" && <div>
                                <div className="custom_modal--body">
                                    <div className="tab_content--body">
                                        {(checkRole !== "admin" && checkRole !== "u_admin") &&
                                            <div className="form_content_block--group modal_form_bottom_gap_d2 w-25 mb-4">
                                                <label className="form_label">Publisher*</label>
                                                <Select
                                                    showSearch={true}
                                                    optionLabelProp="label"
                                                    className='form_select basic --without_search_icon_select'
                                                    placeholder="-Select-"
                                                    options={publisherList}
                                                    onChange={onChangePublisher}
                                                    value={selectedPublisher}
                                                />
                                                <span className="error_content">
                                                    {publisherIsRequiredError && (
                                                        <> This field is required</>
                                                    )}
                                                </span>
                                            </div>
                                        }
                                        <div className="form_content_block--group modal_form_bottom_gap_d2 w-25 mb-4">
                                            <label className="form_label">Platform Type</label>
                                            <Select
                                                showSearch={false}
                                                disabled
                                                // disabled={(inventoryCtvName !== "" || inventoryMobileName !== "" || inventoryWebsiteName !== "")}
                                                value={inventoryType}
                                                onChange={(event) => { setInventoryType(event) }}
                                                optionLabelProp="label"
                                                className='form_select basic'
                                                placeholder="-Select-">
                                                <Option value="Website">Website</Option>
                                                <Option value="CTV">CTV</Option>
                                                <Option value="Mobile App">Mobile App</Option>

                                            </Select>
                                        </div>

                                        {(inventoryCtvName !== "" || inventoryMobileName !== "" || inventoryWebsiteName !== "") &&
                                            <>
                                                <div className='upload_file_design'>
                                                    <div className='svg_with_text'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                            <g clip-path="url(#clip0_8645_29498)">
                                                                <path d="M13.0859 0.625H6.79688C6.32031 0.625 5.86327 0.822544 5.52629 1.17417C5.18931 1.52581 5 2.00272 5 2.5V17.5C5 17.9973 5.18931 18.4742 5.52629 18.8258C5.86327 19.1775 6.32031 19.375 6.79688 19.375H17.5781C18.0547 19.375 18.5117 19.1775 18.8487 18.8258C19.1857 18.4742 19.375 17.9973 19.375 17.5V7.1875L13.0859 0.625Z" stroke="#8952E0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M12.5 0.625V7.5H19.375" stroke="#8952E0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_8645_29498">
                                                                    <rect width="20" height="20" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                        <span>{inventoryType === "Website" ? inventoryWebsiteName : inventoryType === "CTV" ? inventoryCtvName : inventoryMobileName}</span>
                                                    </div>
                                                    <div className='download_icon download_icon_d2'
                                                        onClick={() => {
                                                            setInventoryMobileData([])
                                                            setInventoryMobileName("")
                                                            setInventoryCtvData([])
                                                            setInventoryCtvName("")
                                                            setInventoryWebsiteData([])
                                                            setInventoryWebsiteName("")
                                                        }}
                                                    >
                                                        <img src={DeleteIcon} alt="" className='img-fluid cursor_pointer' />
                                                    </div>
                                                </div>
                                                <div className='modal_table_design'>
                                                    <div className='table_content--box --new_layout_table_design table_empty_screen_d2 user_sync_table_v2 no_data_screen_view table_input_design_cls'>
                                                        <div className="inventory-table-wrapper">
                                                            <Table
                                                                columns={columnsWithActions}
                                                                dataSource={inventoryType === "Website" ? inventoryWebsiteData : inventoryType === "CTV" ? inventoryCtvData : inventoryType === "Mobile App" ? inventoryMobileData : []}
                                                                pagination={false}
                                                                scroll={{ x: "max-content", y: "300px" }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }

                                        {inventoryCtvName === "" && inventoryMobileName === "" && inventoryWebsiteName === "" &&
                                            <div className="form_content_block--group position-relative">
                                                <label for='fileUploader' className='ant_upload_drag --diff_ant_upload_drag'>
                                                    <p className="upload_drag_icon">
                                                        <img src={uploadIcon} alt='USP' />
                                                    </p>
                                                    <p className="ant_upload_text"><b className="primary">Click to upload</b> or drag and drop</p>
                                                    <p className="ant_upload_hint">
                                                        CSV (max. 100 MB)
                                                    </p>
                                                </label>
                                                <input
                                                    className='form_upload d-none'
                                                    type="file"
                                                    id="fileUploader"
                                                    name="fileUploader"
                                                    accept=".xlsx,.xls,.csv"
                                                    onChange={(e) => {
                                                        const file = e.target.files && e.target.files[0];
                                                        if (!file) return;
                                                        handleBeforeUpload(file, inventoryType);
                                                        // optional: allow re-uploading same file
                                                        e.target.value = "";
                                                    }}
                                                />
                                                <h4 className="download_text_icon"
                                                    onClick={() => { handleDownload(filter) }}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                                                        <path d="M11.375 8.125V10.2917C11.375 10.579 11.2609 10.8545 11.0577 11.0577C10.8545 11.2609 10.579 11.375 10.2917 11.375H2.70833C2.42102 11.375 2.14547 11.2609 1.9423 11.0577C1.73914 10.8545 1.625 10.579 1.625 10.2917V8.125" stroke="#FF8218" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M3.79199 5.41669L6.50033 8.12502L9.20866 5.41669" stroke="#FF8218" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M6.5 8.125V1.625" stroke="#FF8218" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                    Download Sample Format
                                                </h4>
                                            </div>
                                        }

                                        <span className="error_content">
                                            {fileUploadError && (
                                                <> This field is required</>
                                            )}
                                        </span>

                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>

                </Modal>


                <Modal
                    maskClosable={false}
                    className='custom_modal'
                    title={<div className='custom_modal--header --tabs'><h3 className='heading'><img src={AdsTxtIcon} alt='USP' /> ads.txt - <span style={{ fontWeight: '400' }}>{modalVisibleAdsTxtData.name}</span></h3>
                        <div className="tab_content--buttons">

                        </div>
                    </div>}
                    visible={isModalVisibleAdsTxt}
                    onCancel={closeModalAdstxt}
                    // onOk={handleOkDiff}
                    closable={true}
                    width={1080}
                    footer={false}
                >
                    <div className="custom_modal--body">
                        <div className="tab_content--body">
                            <div className='error_div_area'>
                                <div className='error_div_area_content'>
                                    <div className='error_icon_svg'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_10469_14089)">
                                                <path d="M5.24065 1.33301H10.7607L14.6673 5.23967V10.7597L10.7607 14.6663H5.24065L1.33398 10.7597V5.23967L5.24065 1.33301Z" stroke="#D92D20" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M8 10.667H8.00667" stroke="#D92D20" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M8 5.33301V7.99967" stroke="#D92D20" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_10469_14089">
                                                    <rect width="16" height="16" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    {modalVisibleAdsTxtData.authoredLines.length === 0 ?
                                        <div className='error_para_text'>
                                            <p>Ads.txt was not found on <span>{modalVisibleAdsTxtData.name}</span></p>
                                            <small>Please add our ads.txt lines from below to avoid missing out on new revenue opportunities.</small>
                                        </div>
                                        :
                                        <div className='error_para_text'>
                                            <p>{modalVisibleAdsTxtData.missingLines} lines are missing on <span>{modalVisibleAdsTxtData.name}</span></p>
                                            <small>Be sure to update your ads.txt file to avoid missing out on new revenue opportunities.</small>
                                        </div>

                                    }

                                </div>
                            </div>
                            {modalVisibleAdsTxtData.authoredLines.length !== 0 &&
                                <div className='code_copy_bg_btn'>
                                    <p style={{ whiteSpace: "pre-line" }}>
                                        {modalVisibleAdsTxtData.authoredLines.join("\n")}
                                    </p>

                                    <Tooltip title={tooltipContent}>
                                        <div className='copy_btn_svg'
                                            onClick={() => { copyToClipboard(modalVisibleAdsTxtData.authoredLines) }}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <g clip-path="url(#clip0_10459_13811)">
                                                    <path d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M3.33398 10.0007H2.66732C2.3137 10.0007 1.97456 9.86018 1.72451 9.61013C1.47446 9.36008 1.33398 9.02094 1.33398 8.66732V2.66732C1.33398 2.3137 1.47446 1.97456 1.72451 1.72451C1.97456 1.47446 2.3137 1.33398 2.66732 1.33398H8.66732C9.02094 1.33398 9.36008 1.47446 9.61013 1.72451C9.86018 1.97456 10.0007 2.3137 10.0007 2.66732V3.33398" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_10459_13811">
                                                        <rect width="16" height="16" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                    </Tooltip>
                                </div>
                            }

                            <div className={modalVisibleAdsTxtData.authoredLines.length === 0 ? 'lines_alert_div --zero_length_text_box' : 'lines_alert_div'}>
                                {modalVisibleAdsTxtData.authoredLines.length !== 0 ?
                                    <div className='svg_alert_line'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_10459_13815)">
                                                <path d="M6.8605 2.57347L1.21384 12.0001C1.09741 12.2018 1.03581 12.4303 1.03516 12.6631C1.03451 12.896 1.09483 13.1249 1.21012 13.3272C1.32541 13.5294 1.49165 13.698 1.69231 13.816C1.89296 13.9341 2.12103 13.9976 2.35384 14.0001H13.6472C13.88 13.9976 14.108 13.9341 14.3087 13.816C14.5094 13.698 14.6756 13.5294 14.7909 13.3272C14.9062 13.1249 14.9665 12.896 14.9658 12.6631C14.9652 12.4303 14.9036 12.2018 14.7872 12.0001L9.1405 2.57347C9.02165 2.37754 8.85432 2.21555 8.65463 2.10313C8.45495 1.9907 8.22966 1.93164 8.0005 1.93164C7.77135 1.93164 7.54606 1.9907 7.34637 2.10313C7.14669 2.21555 6.97935 2.37754 6.8605 2.57347V2.57347Z" stroke="#FF8000" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M8 11.334H8.00667" stroke="#FF8000" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M8 6V8.66667" stroke="#FF8000" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_10459_13815">
                                                    <rect width="16" height="16" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <small>{modalVisibleAdsTxtData.authoredLinesCount} of {modalVisibleAdsTxtData.totalLines} sellers authorized.</small>
                                    </div>
                                    :
                                    <div></div>
                                }
                                {(() => {
                                    const formatted = formatLastCrawledPST(
                                        modalVisibleAdsTxtData?.lastCrawledDate,
                                        modalVisibleAdsTxtData?.lastCrawledTime
                                    );
                                    return formatted ? (
                                        <span>Last crawled on <strong>{formatted}</strong> &nbsp;|&nbsp; Update Frequency: Every 6 hours </span>
                                    ) : null;
                                })()}
                            </div>

                            <hr className='line_modal' />

                            <div className=''>
                                <div>
                                    <div className='collapse_btn_text' onClick={hideShowAdstxtTab}>
                                        <small>Show Missing Lines ({modalVisibleAdsTxtData.missingLines})</small>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ transform: isShowAdstxtTab ? 'rotate(0deg)' : 'rotate(180deg)' }}>
                                            <path d="M15 12.5L10 7.5L5 12.5" stroke="#94A3B8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>

                                    <div className={isShowAdstxtTab === true ? 'collapse_div' : 'collapse_div d-none'}>
                                        <div className='d-flex align-items-center justify-content-between' style={{ marginBottom: '1rem' }}>
                                            <div className='radio_btn_with_bars'>
                                                <div className="radios_btns">
                                                    <Radio.Group
                                                        className='radio_btn--group mb-0'
                                                        value={activeAdstxtTab}
                                                        onChange={handleActiveAdstxttab}
                                                    >

                                                        <Radio.Button value="direct">Direct sellers list</Radio.Button>
                                                        <Radio.Button value="top">Top sellers list</Radio.Button>

                                                    </Radio.Group>
                                                </div>
                                            </div>

                                            <div className='copy_download_btn'>
                                                <Tooltip title={tooltipContent}>
                                                    <div className='diff_copy_btn_svg'

                                                        onClick={() => { copyToClipboard(activeAdstxtTab === "top" ? modalVisibleAdsTxtData.missingLinesTop : modalVisibleAdsTxtData.missingLinesDirect) }}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <g clip-path="url(#clip0_10459_13811)">
                                                                <path d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M3.33398 10.0007H2.66732C2.3137 10.0007 1.97456 9.86018 1.72451 9.61013C1.47446 9.36008 1.33398 9.02094 1.33398 8.66732V2.66732C1.33398 2.3137 1.47446 1.97456 1.72451 1.72451C1.97456 1.47446 2.3137 1.33398 2.66732 1.33398H8.66732C9.02094 1.33398 9.36008 1.47446 9.61013 1.72451C9.86018 1.97456 10.0007 2.3137 10.0007 2.66732V3.33398" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_10459_13811">
                                                                    <rect width="16" height="16" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </div>
                                                </Tooltip>
                                                <div className='diff_copy_btn_svg'
                                                    onClick={() =>
                                                        downloadTxtFile(
                                                            activeAdstxtTab === "top" ? modalVisibleAdsTxtData.missingLinesTop : modalVisibleAdsTxtData.missingLinesDirect,
                                                            activeAdstxtTab === "top"
                                                                ? "top_missing_ads"
                                                                : "direct_missing_ads"
                                                        )
                                                    }
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="#7434DB" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M4.66797 6.66602L8.0013 9.99935L11.3346 6.66602" stroke="#7434DB" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M8 10V2" stroke="#7434DB" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='code_copy_bg_btn'>
                                            {activeAdstxtTab === "top" ?
                                                <p style={{ whiteSpace: "pre-line" }}>
                                                    {modalVisibleAdsTxtData.missingLinesTop.join("\n")}
                                                </p>
                                                :
                                                <p style={{ whiteSpace: "pre-line" }}>
                                                    {modalVisibleAdsTxtData.missingLinesDirect.join("\n")}
                                                </p>
                                            }

                                        </div>
                                        <div className='lines_alert_div'>
                                            <div className='svg_alert_line'>
                                                <small>{activeAdstxtTab === "top" ? modalVisibleAdsTxtData.missingLinesTop.length :
                                                    modalVisibleAdsTxtData.missingLinesDirect.length
                                                } Lines</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal >
            </div>

        </>
    );
};

export default InventoryListing;
